(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3993],{

/***/ 32681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N9t": function() { return /* binding */ OrderDirection; },
/* harmony export */   "d3D": function() { return /* binding */ PostOrderField; },
/* harmony export */   "taS": function() { return /* binding */ EventStatusTypes; }
/* harmony export */ });
/* unused harmony exports AcceleratorMessagingVersionEnum, AccountNotificationSlugType, ActiveCampaignEventSlug, AdminNotificationSlugType, AppFrameLocationsEnum, AssignmentOrderField, AutoRecordingEnum, Avatar, BulkAffiliatesActionEnum, BundleItemEnum, ChangelogEntryVisibilities, ChecklistTypesEnum, CommunityOrderField, CommunityUserOrderField, CourseOrderField, CourseType, CustomPageOrderField, CustomSiteThemeOrderFieldFilter, CustomSiteThemeViewManifestResolverTypeFilter, DiscountEnum, DownloadResourceTypeEnum, DripScheduleStrategyEnum, ElasticPostOrderField, EnrollmentOrderField, EnrollmentStatus, EnrollmentType, EventSourceTypes, EventsOrderField, FeatureLabsComparisonField, FeatureLabsOrderField, FeatureLabsSlug, FunnelStatusEnum, FunnelTypeEnum, IdentityProvider, LessonIconEnum, LessonTypeEnum, Logo, LookerDashboardNameEnum, MonthlyWeekDayEnum, MonthlyWeekEnum, MultimediaSourceTypeEnum, OnboardingFlowType, Operator, OrderBumpSortField, OrderField, OrderFieldFilter, OrderTransactionDetailOrderField, OrderTransactionOrderField, Page, PageGroupKeyEnum, PageScopeKeyEnum, PageStatusEnum, PageTypeEnum, PausedBehavior, PaymentProvider, PaymentType, PlanTypeEnum, PostAttachmentType, PostReactionType, PresentationStatusEnum, PriceTypes, ProductLicenseEventSourceEnum, ProductSortField, ProductStatus, ProductTypes, PromptStatusEnum, PromptTypeEnum, PublicationStatusTypes, QuestionTypeEnum, QuizTypeEnum, ReasonType, RecurrenceTypeEnum, RedirectSitePageView, RefundReason, ReplyOrderField, ReportingOrderField, ResponseStatus, SitePageOrderField, SitePageType, StateType, StatusEnum, StatusTypeEnum, StudentNotificationSlugType, SubmissionOrderField, SubmissionStatus, SurveyQuestionTypeEnum, TaxRegistrationStatus, ThemeInstallationOrderFieldFilter, ThemeLibraryItemVersionStyleOrderFieldFilter, ThemePresetOrderFieldFilter, Transaction, TransactionPricing, TransactionStatus, UserContentOrderField, UserEnrollmentStatus, UserOrderField, UserQuizOrderField, UserRole, UserSurveyOrderField, VideoOrderField, WebinarProviderEnum, ZoomTypeEnum, ZoomUserOrderFieldFilter, ZoomUserStatus, EventFieldsFragmentDoc, LiveEventsEdgesNodeFieldsFragmentDoc, LiveEventsEdgesFieldsFragmentDoc, InterestedUsersEdgesNodeFieldsFragmentDoc, InterestedUsersEdgesFieldsFragmentDoc, EventInterestedUsersFieldsFragmentDoc, CourseFieldsFragmentDoc, ProductsEdgeFieldsFragmentDoc, ProductsFieldsFragmentDoc, SpaceFieldsFragmentDoc, SectionFieldsFragmentDoc, CommunityEdgesNodeUserFieldsFragmentDoc, CommunityEdgesNodeFieldsFragmentDoc, CommunityEdgesFieldsFragmentDoc, UserEnrollmentFieldsFragmentDoc, PostAttachmentsFieldsFragmentDoc, MentionedUsersFieldFragmentDoc, UserFieldsFragmentDoc, PostFieldsWithUserPermissionsFragmentDoc, PostFieldsFragmentDoc, UserFieldsWithPermissionsFragmentDoc, ReplyFieldsWithUserPermissionsFragmentDoc, ReplyFieldsFragmentDoc, ReplyEdgeNodeReliesFieldsFragmentDoc, ReplyEdgeFieldsFragmentDoc, UpdateAccountNotificationDocument, CreateLiveEventDocument, DuplicateLiveEventDocument, UpdateLiveEventDocument, DeleteLiveEventDocument, CreateAttendanceDocument, DeleteAttendanceDocument, LiveEventsDocument, LiveEventDocument, LiveEventsCountDocument, CreatePostDocument, EditPostDocument, DeletePostDocument, FollowPostDocument, UnfollowPostDocument, PinPostDocument, UnpinPostDocument, ToggleReactionOnPostDocument, PostListDocument, PostDocument, CommunityProductRelationsDocument, ProductsDocument, CreateReplyDocument, EditReplyDocument, DeleteReplyDocument, ToggleReactionOnReplyDocument, FollowReplyDocument, UnfollowReplyDocument, ReplyDocument, RepliesDocument, NestedRepliesDocument, ReplyDepthDocument, PostSearchDocument, SectionListDocument, SiteFeaturesDocument, CreateCommunitySpaceDocument, UpdateCommunitySpaceDocument, DeleteCommunitySpaceDocument, ReorderCommunitySpaceDocument, CommunitySpaceDocument, UsersDocument, UserDocument, MainDocument, AccountNotificationsDocument */
var AcceleratorMessagingVersionEnum;
(function(AcceleratorMessagingVersionEnum) {
    AcceleratorMessagingVersionEnum[/** Buy a paid plan to gain access to the accelerator */ "Buy"] = "buy";
    AcceleratorMessagingVersionEnum[/** Join and enroll into the accelerator program */ "Join"] = "join";
    AcceleratorMessagingVersionEnum[/** Visit your accelerator program */ "Visit"] = "visit";
})(AcceleratorMessagingVersionEnum || (AcceleratorMessagingVersionEnum = {}));
var AccountNotificationSlugType;
(function(AccountNotificationSlugType) {
    AccountNotificationSlugType[/** Community comments */ "CommunityPostReply"] = "community_post_reply";
})(AccountNotificationSlugType || (AccountNotificationSlugType = {}));
var ActiveCampaignEventSlug;
(function(ActiveCampaignEventSlug) {
    ActiveCampaignEventSlug[/** ActiveCampaign event Course completed */ "CourseCompleted"] = "course_completed";
    ActiveCampaignEventSlug[/** ActiveCampaign event New enrollment - full */ "NewEnrollmentFull"] = "new_enrollment_full";
    ActiveCampaignEventSlug[/** ActiveCampaign event New enrollment - preview */ "NewEnrollmentTrial"] = "new_enrollment_trial";
    ActiveCampaignEventSlug[/** ActiveCampaign event New order */ "NewOrder"] = "new_order";
    ActiveCampaignEventSlug[/** ActiveCampaign event New sign up */ "NewSignUp"] = "new_sign_up";
})(ActiveCampaignEventSlug || (ActiveCampaignEventSlug = {}));
var AdminNotificationSlugType;
(function(AdminNotificationSlugType) {
    AdminNotificationSlugType[/** Subscription cancelled */ "CancelledSubscription"] = "cancelled_subscription";
    AdminNotificationSlugType[/** Reply */ "DiscussionQuestionAnswered"] = "discussion_question_answered";
    AdminNotificationSlugType[/** Assignment submission */ "NewAssignmentSubmission"] = "new_assignment_submission";
    AdminNotificationSlugType[/** Auto-follow new posts */ "NewCommunityActivity"] = "new_community_activity";
    AdminNotificationSlugType[/** New posts */ "NewCommunityPost"] = "new_community_post";
    AdminNotificationSlugType[/** New post */ "NewDiscussionQuestion"] = "new_discussion_question";
    AdminNotificationSlugType[/** New lead */ "NewLead"] = "new_lead";
    AdminNotificationSlugType[/** New order */ "NewOrder"] = "new_order";
    AdminNotificationSlugType[/** New sign up */ "NewSignup"] = "new_signup";
    AdminNotificationSlugType[/** New review */ "ReviewSubmission"] = "review_submission";
})(AdminNotificationSlugType || (AdminNotificationSlugType = {}));
var AppFrameLocationsEnum;
(function(AppFrameLocationsEnum) {
    AppFrameLocationsEnum[/** Injects App Frame into app settings page */ "AppSettings"] = "APP_SETTINGS";
    AppFrameLocationsEnum[/** Injects App Frame in the Communities background */ "CommunitiesBackground"] = "COMMUNITIES_BACKGROUND";
    AppFrameLocationsEnum[/** Injects App Frame in the Course Player background */ "CoursePlayerBackground"] = "COURSE_PLAYER_BACKGROUND";
    AppFrameLocationsEnum[/** Injects App Frame in the Performance Checkout background */ "PerformanceCheckoutBackground"] = "PERFORMANCE_CHECKOUT_BACKGROUND";
    AppFrameLocationsEnum[/** Injects App Frame in the Theme background */ "ThemeBackground"] = "THEME_BACKGROUND";
})(AppFrameLocationsEnum || (AppFrameLocationsEnum = {}));
var AssignmentOrderField;
(function(AssignmentOrderField) {
    AssignmentOrderField[/** order assignments by file size */ "CreatedAt"] = "createdAt";
    AssignmentOrderField[/** order assignments by file size */ "FileSizeLimit"] = "fileSizeLimit";
    AssignmentOrderField[/** order assignments by title */ "Title"] = "title";
    AssignmentOrderField[/** order assignments by file size */ "UpdatedAt"] = "updatedAt";
})(AssignmentOrderField || (AssignmentOrderField = {}));
var AutoRecordingEnum;
(function(AutoRecordingEnum) {
    AutoRecordingEnum[/** auto recording cloud type */ "Cloud"] = "cloud";
    AutoRecordingEnum[/** auto recording local type */ "Local"] = "local";
    AutoRecordingEnum[/** auto recording empty type */ "None"] = "none";
})(AutoRecordingEnum || (AutoRecordingEnum = {}));
var Avatar;
(function(Avatar) {
    Avatar[/** Medium (540x540 px) */ "Medium"] = "medium";
    Avatar[/** Small (220x220 px) */ "Small"] = "small";
    Avatar[/** Thumb (50x50 px) */ "Thumb"] = "thumb";
})(Avatar || (Avatar = {}));
var BulkAffiliatesActionEnum;
(function(BulkAffiliatesActionEnum) {
    BulkAffiliatesActionEnum[/** add all affiliates from a product */ "Add"] = "ADD";
    BulkAffiliatesActionEnum[/** remove all affiliates from a product */ "Remove"] = "REMOVE";
})(BulkAffiliatesActionEnum || (BulkAffiliatesActionEnum = {}));
var BundleItemEnum;
(function(BundleItemEnum) {
    BundleItemEnum[/** Search for Communities */ "Community"] = "Community";
    BundleItemEnum[/** Search for Courses */ "Course"] = "Course";
    BundleItemEnum[/** Search for Digital Downloads */ "DigitalDownload"] = "DigitalDownload";
    BundleItemEnum[/** Search for Live Events */ "LiveEvent"] = "LiveEvent";
})(BundleItemEnum || (BundleItemEnum = {}));
var ChangelogEntryVisibilities;
(function(ChangelogEntryVisibilities) {
    ChangelogEntryVisibilities[/** Entry shows both internally and externally */ "All"] = "all";
    ChangelogEntryVisibilities[/** Entry only shows on public Changelog page (changelog.thinkific.com) */ "External"] = "external";
    ChangelogEntryVisibilities[/** Entry only shows in Tenant Dashboard area (AnnouncementModal, Internal Changelog) */ "Internal"] = "internal";
})(ChangelogEntryVisibilities || (ChangelogEntryVisibilities = {}));
var ChecklistTypesEnum;
(function(ChecklistTypesEnum) {
    ChecklistTypesEnum[/** Communities onboarding checklist */ "Communities"] = "communities";
    ChecklistTypesEnum[/** Courses onboarding checklist */ "Courses"] = "courses";
    ChecklistTypesEnum[/** Get started onboarding checklist */ "GetStarted"] = "get_started";
    ChecklistTypesEnum[/** Launch onboarding checklist */ "Launch"] = "launch";
})(ChecklistTypesEnum || (ChecklistTypesEnum = {}));
var CommunityOrderField;
(function(CommunityOrderField) {
    CommunityOrderField[/** Order communities by created_at */ "CreatedAt"] = "CREATED_AT";
    CommunityOrderField[/** Order communities by product_position */ "ProductPosition"] = "PRODUCT_POSITION";
})(CommunityOrderField || (CommunityOrderField = {}));
var CommunityUserOrderField;
(function(CommunityUserOrderField) {
    CommunityUserOrderField[/** Order community users by community_name */ "CommunityName"] = "COMMUNITY_NAME";
    CommunityUserOrderField[/** Order community users by created_at */ "CreatedAt"] = "CREATED_AT";
    CommunityUserOrderField[/** Order community users by expires_at */ "ExpiresAt"] = "EXPIRES_AT";
})(CommunityUserOrderField || (CommunityUserOrderField = {}));
var CourseOrderField;
(function(CourseOrderField) {
    CourseOrderField[/** Order courses by created at time */ "CreatedAt"] = "createdAt";
})(CourseOrderField || (CourseOrderField = {}));
var CourseType;
(function(CourseType) {
    CourseType[/** The course is a Channels Course */ "Channels"] = "channels";
    CourseType[/** The course is a Scorm Course */ "Scorm"] = "scorm";
})(CourseType || (CourseType = {}));
var CustomPageOrderField;
(function(CustomPageOrderField) {
    CustomPageOrderField[/** Order custom pages by editedAt for the active theme */ "EditedAt"] = "EDITED_AT";
    CustomPageOrderField[/** Order custom pages by id */ "Id"] = "ID";
    CustomPageOrderField[/** Order custom pages by name */ "Name"] = "NAME";
})(CustomPageOrderField || (CustomPageOrderField = {}));
var CustomSiteThemeOrderFieldFilter;
(function(CustomSiteThemeOrderFieldFilter) {
    CustomSiteThemeOrderFieldFilter[/** Order custom site themes by id */ "Id"] = "ID";
})(CustomSiteThemeOrderFieldFilter || (CustomSiteThemeOrderFieldFilter = {}));
var CustomSiteThemeViewManifestResolverTypeFilter;
(function(CustomSiteThemeViewManifestResolverTypeFilter) {
    CustomSiteThemeViewManifestResolverTypeFilter[/** Custom page type */ "CustomPage"] = "CustomPage";
    CustomSiteThemeViewManifestResolverTypeFilter[/** Product type */ "Product"] = "Product";
})(CustomSiteThemeViewManifestResolverTypeFilter || (CustomSiteThemeViewManifestResolverTypeFilter = {}));
var DiscountEnum;
(function(DiscountEnum) {
    DiscountEnum[/** takes a fixed amount off of the price */ "Fixed"] = "fixed";
    DiscountEnum[/** takes a percentage off of the price */ "Percentage"] = "percentage";
})(DiscountEnum || (DiscountEnum = {}));
var DownloadResourceTypeEnum;
(function(DownloadResourceTypeEnum) {
    DownloadResourceTypeEnum[/** Checklist */ "Checklist"] = "Checklist";
    DownloadResourceTypeEnum[/** Other */ "Download"] = "Download";
    DownloadResourceTypeEnum[/** Ebook */ "Ebook"] = "Ebook";
    DownloadResourceTypeEnum[/** Framework */ "Framework"] = "Framework";
    DownloadResourceTypeEnum[/** Guide */ "Guide"] = "Guide";
    DownloadResourceTypeEnum[/** Resource List */ "ResourceList"] = "ResourceList";
    DownloadResourceTypeEnum[/** Template */ "Template"] = "Template";
    DownloadResourceTypeEnum[/** Whitepaper */ "Whitepaper"] = "Whitepaper";
    DownloadResourceTypeEnum[/** Worksheet */ "Worksheet"] = "Worksheet";
})(DownloadResourceTypeEnum || (DownloadResourceTypeEnum = {}));
var DripScheduleStrategyEnum;
(function(DripScheduleStrategyEnum) {
    DripScheduleStrategyEnum[/** Strategy is relative to student enrollment date */ "RelativeToEnrollmentDate"] = "relative_to_enrollment_date";
    DripScheduleStrategyEnum[/** Strategy is relative to release date */ "RelativeToReleaseDate"] = "relative_to_release_date";
    DripScheduleStrategyEnum[/** Strategy is relative to student start course date */ "RelativeToStudentStartCourseDate"] = "relative_to_student_start_course_date";
})(DripScheduleStrategyEnum || (DripScheduleStrategyEnum = {}));
var ElasticPostOrderField;
(function(ElasticPostOrderField) {
    ElasticPostOrderField[/** Order posts by content_name */ "ContentName"] = "CONTENT_NAME";
    ElasticPostOrderField[/** Order posts by course_name */ "CourseName"] = "COURSE_NAME";
    ElasticPostOrderField[/** Order posts by created_at */ "CreatedAt"] = "CREATED_AT";
    ElasticPostOrderField[/** Order posts by last_interaction_at */ "LastInteractionAt"] = "LAST_INTERACTION_AT";
    ElasticPostOrderField[/** Order posts by pinned_at */ "PinnedAt"] = "PINNED_AT";
    ElasticPostOrderField[/** Order posts by reply_count */ "ReplyCount"] = "REPLY_COUNT";
    ElasticPostOrderField[/** Order posts by title */ "Title"] = "TITLE";
    ElasticPostOrderField[/** Order posts by updated_at */ "UpdatedAt"] = "UPDATED_AT";
})(ElasticPostOrderField || (ElasticPostOrderField = {}));
var EnrollmentOrderField;
(function(EnrollmentOrderField) {
    EnrollmentOrderField[/** Order enrollments by activated_at */ "ActivatedAt"] = "ACTIVATED_AT";
    EnrollmentOrderField[/** Order enrollments by completed_at */ "CompletedAt"] = "COMPLETED_AT";
    EnrollmentOrderField[/** Order enrollments by course_name */ "CourseName"] = "COURSE_NAME";
    EnrollmentOrderField[/** Order enrollments by expiry_date */ "ExpiryDate"] = "EXPIRY_DATE";
    EnrollmentOrderField[/** Order enrollments by percentage_completed */ "PercentageCompleted"] = "PERCENTAGE_COMPLETED";
})(EnrollmentOrderField || (EnrollmentOrderField = {}));
var EnrollmentStatus;
(function(EnrollmentStatus) {
    EnrollmentStatus[/** Users with active enrollment in courses */ "Active"] = "ACTIVE";
    EnrollmentStatus[/** Users with expired enrollment in courses */ "Expired"] = "EXPIRED";
    EnrollmentStatus[/** Users who never enrollment in courses */ "Never"] = "NEVER";
})(EnrollmentStatus || (EnrollmentStatus = {}));
var EnrollmentType;
(function(EnrollmentType) {
    EnrollmentType[/** Active enrollment in courses */ "Active"] = "ACTIVE";
    EnrollmentType[/** Free trial enrollment in courses */ "FreeTrial"] = "FREE_TRIAL";
})(EnrollmentType || (EnrollmentType = {}));
var EventSourceTypes;
(function(EventSourceTypes) {
    EventSourceTypes[/** Filter by Community Event Source Type */ "Community"] = "Community";
})(EventSourceTypes || (EventSourceTypes = {}));
var EventStatusTypes;
(function(EventStatusTypes) {
    EventStatusTypes[/** View expired events */ "Expired"] = "EXPIRED";
    EventStatusTypes[/** View upcoming events */ "Upcoming"] = "UPCOMING";
})(EventStatusTypes || (EventStatusTypes = {}));
var EventsOrderField;
(function(EventsOrderField) {
    EventsOrderField[/** Order events by end_time */ "EndTime"] = "end_time";
    EventsOrderField[/** Order events by start_time */ "StartTime"] = "start_time";
})(EventsOrderField || (EventsOrderField = {}));
var FeatureLabsComparisonField;
(function(FeatureLabsComparisonField) {
    FeatureLabsComparisonField[/** filter field by after given date */ "After"] = "after";
    FeatureLabsComparisonField[/** filter field by before given date */ "Before"] = "before";
})(FeatureLabsComparisonField || (FeatureLabsComparisonField = {}));
var FeatureLabsOrderField;
(function(FeatureLabsOrderField) {
    FeatureLabsOrderField[/** order user contents by createdAt date */ "CreatedAt"] = "createdAt";
    FeatureLabsOrderField[/** order user contents by expiresAt date */ "ExpiresAt"] = "expiresAt";
    FeatureLabsOrderField[/** order user contents by createdAt date */ "HighlightedAt"] = "highlightedAt";
})(FeatureLabsOrderField || (FeatureLabsOrderField = {}));
var FeatureLabsSlug;
(function(FeatureLabsSlug) {
    FeatureLabsSlug[/**
   * Lab slug for Site Pages feature
   * @deprecated No longer a feature in labs
   */ "SitePages"] = "site_pages";
})(FeatureLabsSlug || (FeatureLabsSlug = {}));
var FunnelStatusEnum;
(function(FunnelStatusEnum) {
    FunnelStatusEnum[/** The funnel has never been published */ "Draft"] = "Draft";
    FunnelStatusEnum[/** The funnel is published and live */ "Published"] = "Published";
    FunnelStatusEnum[/** The funnel was previously published, but is now unpublished */ "Unpublished"] = "Unpublished";
})(FunnelStatusEnum || (FunnelStatusEnum = {}));
var FunnelTypeEnum;
(function(FunnelTypeEnum) {
    FunnelTypeEnum[/** Offers a free download file */ "FreeDownloadFunnel"] = "FreeDownloadFunnel";
    FunnelTypeEnum[/** Offers a free preview lesson */ "FreeLessonFunnel"] = "FreeLessonFunnel";
    FunnelTypeEnum[/** Offers a unique sales page for a product of any type */ "ProductPageFunnel"] = "ProductPageFunnel";
    FunnelTypeEnum[/** Offers a unique sales page for a product */ "SalesPageFunnel"] = "SalesPageFunnel";
})(FunnelTypeEnum || (FunnelTypeEnum = {}));
var IdentityProvider;
(function(IdentityProvider) {
    IdentityProvider[/** OpenId Connect */ "OpenidConnect"] = "OPENID_CONNECT";
    IdentityProvider[/** Partner Portal */ "PartnerPortal"] = "PARTNER_PORTAL";
    IdentityProvider[/** Single sign on */ "Sso"] = "SSO";
    IdentityProvider[/** Apple */ "Apple"] = "apple";
    IdentityProvider[/** Facebook */ "Facebook"] = "facebook";
    IdentityProvider[/** Google */ "Google"] = "google";
    IdentityProvider[/** Linked In */ "Linkedin"] = "linkedin";
    IdentityProvider[/** Thinkific Accounts */ "ThinkificAccounts"] = "thinkific_accounts";
})(IdentityProvider || (IdentityProvider = {}));
var LessonIconEnum;
(function(LessonIconEnum) {
    LessonIconEnum[/** assignment contentable type icon */ "Assignment"] = "assignment";
    LessonIconEnum[/** audio contentable type icon */ "Audio"] = "audio";
    LessonIconEnum[/** discussions contentable type icon */ "Discussions"] = "discussions";
    LessonIconEnum[/** download contentable type icon */ "Download"] = "download";
    LessonIconEnum[/** exam contentable type icon */ "Exam"] = "exam";
    LessonIconEnum[/** live lesson contentable type icon */ "Live"] = "live";
    LessonIconEnum[/** Iframe contentable type icon */ "Multimedia"] = "multimedia";
    LessonIconEnum[/** pdf lesson contentable type icon */ "Pdf"] = "pdf";
    LessonIconEnum[/** presentation lesson contentable type icon */ "Presentation"] = "presentation";
    LessonIconEnum[/** quiz lesson contentable type icon */ "Quiz"] = "quiz";
    LessonIconEnum[/** survey lesson contentable type icon */ "Survey"] = "survey";
    LessonIconEnum[/** HtmlItem contentable type icon */ "Text"] = "text";
    LessonIconEnum[/** video lesson contentable type icon */ "Video"] = "video";
})(LessonIconEnum || (LessonIconEnum = {}));
var LessonTypeEnum;
(function(LessonTypeEnum) {
    LessonTypeEnum[/** Assignment Lesson */ "Assignment"] = "Assignment";
    LessonTypeEnum[/** Audio Lesson */ "Audio"] = "Audio";
    LessonTypeEnum[/** BrilliumExam Lesson */ "BrilliumExam"] = "BrilliumExam";
    LessonTypeEnum[/** Discussion Lesson */ "Disqus"] = "Disqus";
    LessonTypeEnum[/** Download Lesson */ "Download"] = "Download";
    LessonTypeEnum[/** Text Lesson */ "HtmlItem"] = "HtmlItem";
    LessonTypeEnum[/** Multimedia Lesson */ "Iframe"] = "Iframe";
    LessonTypeEnum[/** Video Lesson */ "Lesson"] = "Lesson";
    LessonTypeEnum[/** LiveLesson Lesson */ "LiveLesson"] = "LiveLesson";
    LessonTypeEnum[/** PDF Lesson */ "Pdf"] = "Pdf";
    LessonTypeEnum[/** Presentation Lesson */ "Presentation"] = "Presentation";
    LessonTypeEnum[/** Quiz Lesson */ "Quiz"] = "Quiz";
    LessonTypeEnum[/** Survey Lesson */ "Survey"] = "Survey";
})(LessonTypeEnum || (LessonTypeEnum = {}));
var Logo;
(function(Logo) {
    Logo[/** Large (500x500 px) */ "Large"] = "large";
    Logo[/** Medium (370x370 px) */ "Medium"] = "medium";
    Logo[/** Small (325x125 px) */ "Small"] = "small";
})(Logo || (Logo = {}));
var LookerDashboardNameEnum;
(function(LookerDashboardNameEnum) {
    LookerDashboardNameEnum[/** 'Checkout conversion' dashboard */ "CheckoutConversion"] = "CHECKOUT_CONVERSION";
    LookerDashboardNameEnum[/** 'Communities' dashboard */ "Communities"] = "COMMUNITIES";
    LookerDashboardNameEnum[/** 'Course engagement' dashboard */ "CourseEngagement"] = "COURSE_ENGAGEMENT";
    LookerDashboardNameEnum[/** 'Enrollments' dashboard */ "Enrollments"] = "ENROLLMENTS";
    LookerDashboardNameEnum[/** 'Leads' dashboard */ "Leads"] = "LEADS";
    LookerDashboardNameEnum[/** 'Orders' dashboard */ "Orders"] = "ORDERS";
    LookerDashboardNameEnum[/** 'Quiz' dashboard */ "Quiz"] = "QUIZ";
    LookerDashboardNameEnum[/** 'Revenue' dashboard */ "Revenue"] = "REVENUE";
    LookerDashboardNameEnum[/** 'Scorm assessments' dashboard */ "ScormAssessments"] = "SCORM_ASSESSMENTS";
    LookerDashboardNameEnum[/** 'Student engagement' dashboard */ "StudentEngagement"] = "STUDENT_ENGAGEMENT";
    LookerDashboardNameEnum[/** 'Student engagement overview' dashboard */ "StudentEngagementOverview"] = "STUDENT_ENGAGEMENT_OVERVIEW";
    LookerDashboardNameEnum[/** 'Student performance' dashboard */ "StudentPerformance"] = "STUDENT_PERFORMANCE";
    LookerDashboardNameEnum[/** 'Subscriptions' dashboard */ "Subscriptions"] = "SUBSCRIPTIONS";
    LookerDashboardNameEnum[/** 'Visitors' dashboard */ "Visitors"] = "VISITORS";
})(LookerDashboardNameEnum || (LookerDashboardNameEnum = {}));
var MonthlyWeekDayEnum;
(function(MonthlyWeekDayEnum) {
    MonthlyWeekDayEnum["Friday"] = "Friday";
    MonthlyWeekDayEnum["Monday"] = "Monday";
    MonthlyWeekDayEnum["Saturday"] = "Saturday";
    MonthlyWeekDayEnum["Sunday"] = "Sunday";
    MonthlyWeekDayEnum["Thursday"] = "Thursday";
    MonthlyWeekDayEnum["Tuesday"] = "Tuesday";
    MonthlyWeekDayEnum["Wednesday"] = "Wednesday";
})(MonthlyWeekDayEnum || (MonthlyWeekDayEnum = {}));
var MonthlyWeekEnum;
(function(MonthlyWeekEnum) {
    MonthlyWeekEnum[/** First week of the month */ "First"] = "First";
    MonthlyWeekEnum[/** Fourth week of the month */ "Fourth"] = "Fourth";
    MonthlyWeekEnum[/** Last week of the month */ "Last"] = "Last";
    MonthlyWeekEnum[/** Second week of the month */ "Second"] = "Second";
    MonthlyWeekEnum[/** Third week of the month */ "Third"] = "Third";
})(MonthlyWeekEnum || (MonthlyWeekEnum = {}));
var MultimediaSourceTypeEnum;
(function(MultimediaSourceTypeEnum) {
    MultimediaSourceTypeEnum[/** External source type */ "External"] = "external";
    MultimediaSourceTypeEnum[/** Uploaded source type */ "Uploaded"] = "uploaded";
})(MultimediaSourceTypeEnum || (MultimediaSourceTypeEnum = {}));
var OnboardingFlowType;
(function(OnboardingFlowType) {
    OnboardingFlowType[/** api_flow Onboarding flow */ "ApiFlow"] = "api_flow";
    OnboardingFlowType[/** paid_flow Onboarding flow */ "PaidFlow"] = "paid_flow";
    OnboardingFlowType[/** promo_flow_v2 Onboarding flow */ "PromoFlowV2"] = "promo_flow_v2";
    OnboardingFlowType[/** signin_flow Onboarding flow */ "SigninFlow"] = "signin_flow";
    OnboardingFlowType[/** signup_flow Onboarding flow */ "SignupFlow"] = "signup_flow";
})(OnboardingFlowType || (OnboardingFlowType = {}));
var Operator;
(function(Operator) {
    Operator[/** Equal to */ "Eq"] = "EQ";
    Operator[/** Greater than */ "Gt"] = "GT";
    Operator[/** Greater than or equal to */ "Gte"] = "GTE";
    Operator[/** Lesser than */ "Lt"] = "LT";
    Operator[/** Lesser than or equal to */ "Lte"] = "LTE";
})(Operator || (Operator = {}));
var OrderBumpSortField;
(function(OrderBumpSortField) {
    OrderBumpSortField[/** Sort by created at */ "CreatedAt"] = "CREATED_AT";
    OrderBumpSortField[/** Sort by name */ "Name"] = "NAME";
    OrderBumpSortField[/** Sort by price */ "PriceInCents"] = "PRICE_IN_CENTS";
})(OrderBumpSortField || (OrderBumpSortField = {}));
var OrderDirection;
(function(OrderDirection) {
    OrderDirection[/** Ascending order for a given orderBy argument */ "Asc"] = "ASC";
    OrderDirection[/** Descending order for a given orderBy argument */ "Desc"] = "DESC";
})(OrderDirection || (OrderDirection = {}));
var OrderField;
(function(OrderField) {
    OrderField[/** Order user bundles by bundle_name */ "BundleName"] = "BUNDLE_NAME";
    OrderField[/** Order user bundles by created_at */ "CreatedAt"] = "CREATED_AT";
    OrderField[/** Order user bundles by expiry_date */ "ExpiryDate"] = "EXPIRY_DATE";
    OrderField[/** Order user bundles by updated_at */ "UpdatedAt"] = "UPDATED_AT";
})(OrderField || (OrderField = {}));
var OrderFieldFilter;
(function(OrderFieldFilter) {
    OrderFieldFilter[/** order lessons by the number of completed user lessons it has */ "CompletedUserContentsCount"] = "completedUserContentsCount";
    OrderFieldFilter[/** order lessons by name of course it belongs to */ "CourseName"] = "courseName";
    OrderFieldFilter[/** order lessons by the date of the last completed user content */ "LastCompletedUserContentDate"] = "lastCompletedUserContentDate";
    OrderFieldFilter[/** order lessons by name */ "Name"] = "name";
    OrderFieldFilter[/** order lessons by type */ "Type"] = "type";
})(OrderFieldFilter || (OrderFieldFilter = {}));
var OrderTransactionDetailOrderField;
(function(OrderTransactionDetailOrderField) {
    OrderTransactionDetailOrderField[/** Order transaction detail by affiliate */ "Affiliate"] = "AFFILIATE";
    OrderTransactionDetailOrderField[/** Order transaction detail by amount */ "Amount"] = "AMOUNT";
    OrderTransactionDetailOrderField[/** Order transaction detail by card_expiry_date */ "CardExpiryDate"] = "CARD_EXPIRY_DATE";
    OrderTransactionDetailOrderField[/** Order transaction detail by card_last4_digits */ "CardLast4Digits"] = "CARD_LAST4_DIGITS";
    OrderTransactionDetailOrderField[/** Order transaction detail by card_type */ "CardType"] = "CARD_TYPE";
    OrderTransactionDetailOrderField[/** Order transaction detail by country_code */ "CountryCode"] = "COUNTRY_CODE";
    OrderTransactionDetailOrderField[/** Order transaction detail by coupon_code */ "CouponCode"] = "COUPON_CODE";
    OrderTransactionDetailOrderField[/** Order transaction detail by coupon_discount */ "CouponDiscount"] = "COUPON_DISCOUNT";
    OrderTransactionDetailOrderField[/** Order transaction detail by coupon_name */ "CouponName"] = "COUPON_NAME";
    OrderTransactionDetailOrderField[/** Order transaction detail by currency */ "Currency"] = "CURRENCY";
    OrderTransactionDetailOrderField[/** Order transaction detail by email */ "Email"] = "EMAIL";
    OrderTransactionDetailOrderField[/** Order transaction detail by failure_reason */ "FailureReason"] = "FAILURE_REASON";
    OrderTransactionDetailOrderField[/** Order transaction detail by fee */ "Fee"] = "FEE";
    OrderTransactionDetailOrderField[/** Order transaction detail by format_currency_amount */ "FormatCurrencyAmount"] = "FORMAT_CURRENCY_AMOUNT";
    OrderTransactionDetailOrderField[/** Order transaction detail by full_name */ "FullName"] = "FULL_NAME";
    OrderTransactionDetailOrderField[/** Order transaction detail by id */ "Id"] = "ID";
    OrderTransactionDetailOrderField[/** Order transaction detail by invoice_id */ "InvoiceId"] = "INVOICE_ID";
    OrderTransactionDetailOrderField[/** Order transaction detail by net_amount */ "NetAmount"] = "NET_AMOUNT";
    OrderTransactionDetailOrderField[/** Order transaction detail by order_bumps */ "OrderBumps"] = "ORDER_BUMPS";
    OrderTransactionDetailOrderField[/** Order transaction detail by order_id */ "OrderId"] = "ORDER_ID";
    OrderTransactionDetailOrderField[/** Order transaction detail by order_number */ "OrderNumber"] = "ORDER_NUMBER";
    OrderTransactionDetailOrderField[/** Order transaction detail by order_transaction_id */ "OrderTransactionId"] = "ORDER_TRANSACTION_ID";
    OrderTransactionDetailOrderField[/** Order transaction detail by payment_method */ "PaymentMethod"] = "PAYMENT_METHOD";
    OrderTransactionDetailOrderField[/** Order transaction detail by payment_provider */ "PaymentProvider"] = "PAYMENT_PROVIDER";
    OrderTransactionDetailOrderField[/** Order transaction detail by price_label */ "PriceLabel"] = "PRICE_LABEL";
    OrderTransactionDetailOrderField[/** Order transaction detail by price_type */ "PriceType"] = "PRICE_TYPE";
    OrderTransactionDetailOrderField[/** Order transaction detail by product_name */ "ProductName"] = "PRODUCT_NAME";
    OrderTransactionDetailOrderField[/** Order transaction detail by provider_charge_id */ "ProviderChargeId"] = "PROVIDER_CHARGE_ID";
    OrderTransactionDetailOrderField[/** Order transaction detail by refunded_amount */ "RefundedAmount"] = "REFUNDED_AMOUNT";
    OrderTransactionDetailOrderField[/** Order transaction detail by refund_reason */ "RefundReason"] = "REFUND_REASON";
    OrderTransactionDetailOrderField[/** Order transaction detail by sales_tax */ "SalesTax"] = "SALES_TAX";
    OrderTransactionDetailOrderField[/** Order transaction detail by subtotal */ "Subtotal"] = "SUBTOTAL";
    OrderTransactionDetailOrderField[/** Order transaction detail by tenant_id */ "TenantId"] = "TENANT_ID";
    OrderTransactionDetailOrderField[/** Order transaction detail by transaction_date */ "TransactionDate"] = "TRANSACTION_DATE";
    OrderTransactionDetailOrderField[/** Order transaction detail by transaction_status */ "TransactionStatus"] = "TRANSACTION_STATUS";
    OrderTransactionDetailOrderField[/** Order transaction detail by transaction_type */ "TransactionType"] = "TRANSACTION_TYPE";
    OrderTransactionDetailOrderField[/** Order transaction detail by user_id */ "UserId"] = "USER_ID";
    OrderTransactionDetailOrderField[/** Order transaction detail by user_region */ "UserRegion"] = "USER_REGION";
    OrderTransactionDetailOrderField[/** Order transaction detail by zip_code */ "ZipCode"] = "ZIP_CODE";
})(OrderTransactionDetailOrderField || (OrderTransactionDetailOrderField = {}));
var OrderTransactionOrderField;
(function(OrderTransactionOrderField) {
    OrderTransactionOrderField[/** Order transactions by amount_in_dollars */ "AmountInDollars"] = "AMOUNT_IN_DOLLARS";
    OrderTransactionOrderField[/** Order transactions by application_fee */ "ApplicationFee"] = "APPLICATION_FEE";
    OrderTransactionOrderField[/** Order transactions by created_at */ "CreatedAt"] = "CREATED_AT";
    OrderTransactionOrderField[/** Order transactions by cumulative_order_value */ "CumulativeOrderValue"] = "CUMULATIVE_ORDER_VALUE";
    OrderTransactionOrderField[/** Order transactions by email */ "Email"] = "EMAIL";
    OrderTransactionOrderField[/** Order transactions by first_name */ "FirstName"] = "FIRST_NAME";
    OrderTransactionOrderField[/** Order transactions by last_name */ "LastName"] = "LAST_NAME";
    OrderTransactionOrderField[/** Order transactions by order_number */ "OrderNumber"] = "ORDER_NUMBER";
    OrderTransactionOrderField[/** Order transactions by order_referrer */ "OrderReferrer"] = "ORDER_REFERRER";
    OrderTransactionOrderField[/** Order transactions by payment_method */ "PaymentMethod"] = "PAYMENT_METHOD";
    OrderTransactionOrderField[/** Order transactions by payment_provider */ "PaymentProvider"] = "PAYMENT_PROVIDER";
    OrderTransactionOrderField[/** Order transactions by payment_type */ "PaymentType"] = "PAYMENT_TYPE";
    OrderTransactionOrderField[/** Order transactions by product_name */ "ProductName"] = "PRODUCT_NAME";
    OrderTransactionOrderField[/** Order transactions by status */ "Status"] = "STATUS";
    OrderTransactionOrderField[/** Order transactions by updated_at */ "UpdatedAt"] = "UPDATED_AT";
})(OrderTransactionOrderField || (OrderTransactionOrderField = {}));
var Page;
(function(Page) {
    Page[/** Custom page */ "Custom"] = "CUSTOM";
    Page[/** Default page */ "Default"] = "DEFAULT";
    Page[/** Product page */ "Product"] = "PRODUCT";
    Page[/** Thank you page */ "ThankYou"] = "THANK_YOU";
})(Page || (Page = {}));
var PageGroupKeyEnum;
(function(PageGroupKeyEnum) {
    PageGroupKeyEnum[/** all pages that allow site scripts */ "All"] = "all";
    PageGroupKeyEnum[/** checkout-related pages that allow site scripts */ "Checkout"] = "checkout";
    PageGroupKeyEnum[/** individual pages specified to allow site scripts */ "IndividualPages"] = "individual_pages";
    PageGroupKeyEnum[/** landing pages that allow site scripts */ "LandingPages"] = "landing_pages";
    PageGroupKeyEnum[/** pages that drive student learning experiences that allow site scripts */ "LearningExperience"] = "learning_experience";
})(PageGroupKeyEnum || (PageGroupKeyEnum = {}));
var PageScopeKeyEnum;
(function(PageScopeKeyEnum) {
    PageScopeKeyEnum["BundleLandingPage"] = "bundle_landing_page";
    PageScopeKeyEnum["CheckoutThankyouPage"] = "checkout_thankyou_page";
    PageScopeKeyEnum["CollectionsLandingPage"] = "collections_landing_page";
    PageScopeKeyEnum["ComingSoonPage"] = "coming_soon_page";
    PageScopeKeyEnum["CourseLandingPage"] = "course_landing_page";
    PageScopeKeyEnum["CoursePlayer"] = "course_player";
    PageScopeKeyEnum["HomeLandingPage"] = "home_landing_page";
    PageScopeKeyEnum["PageTemplate"] = "page_template";
    PageScopeKeyEnum["StudentDashboard"] = "student_dashboard";
})(PageScopeKeyEnum || (PageScopeKeyEnum = {}));
var PageStatusEnum;
(function(PageStatusEnum) {
    PageStatusEnum[/** Page is draft */ "Draft"] = "DRAFT";
    PageStatusEnum[/** Page is published */ "Published"] = "PUBLISHED";
})(PageStatusEnum || (PageStatusEnum = {}));
var PageTypeEnum;
(function(PageTypeEnum) {
    PageTypeEnum[/** Bundle page */ "Bundle"] = "bundle";
    PageTypeEnum[/** Course page */ "Course"] = "course";
    PageTypeEnum[/** Custom page */ "Custom"] = "custom";
    PageTypeEnum[/** Default page */ "Default"] = "default";
    PageTypeEnum[/** Product page */ "Product"] = "product";
    PageTypeEnum[/** Thank you page */ "ThankYou"] = "thank_you";
})(PageTypeEnum || (PageTypeEnum = {}));
var PausedBehavior;
(function(PausedBehavior) {
    PausedBehavior[/** allow access */ "AllowAccess"] = "allow_access";
    PausedBehavior[/** block access */ "BlockAccess"] = "block_access";
})(PausedBehavior || (PausedBehavior = {}));
var PaymentProvider;
(function(PaymentProvider) {
    PaymentProvider[/** PayPal */ "Paypal"] = "PAYPAL";
    PaymentProvider[/** PayPal Smart */ "PaypalSmart"] = "PAYPAL_SMART";
    PaymentProvider[/** Stripe standard integration */ "Stripe"] = "STRIPE";
    PaymentProvider[/** Thinkific Payments */ "ThinkificPayments"] = "THINKIFIC_PAYMENTS";
})(PaymentProvider || (PaymentProvider = {}));
var PaymentType;
(function(PaymentType) {
    PaymentType[/** Free */ "Free"] = "free";
    PaymentType[/** One-time payment */ "OneTime"] = "one_time";
    PaymentType[/** Monthly payment plan */ "PaymentPlan"] = "payment_plan";
    PaymentType[/** Subscription / Membership */ "Subscription"] = "subscription";
})(PaymentType || (PaymentType = {}));
var PlanTypeEnum;
(function(PlanTypeEnum) {
    PlanTypeEnum[/** Site plan represents one of the addon plans offered */ "Addon"] = "addon";
    PlanTypeEnum[/** Site plan represents one of the main plans offered */ "Main"] = "main";
})(PlanTypeEnum || (PlanTypeEnum = {}));
var PostAttachmentType;
(function(PostAttachmentType) {
    PostAttachmentType[/** File attachment type */ "File"] = "file";
    PostAttachmentType[/** Image attachment type */ "Image"] = "image";
    PostAttachmentType[/** Video attachment type */ "Video"] = "video";
})(PostAttachmentType || (PostAttachmentType = {}));
var PostOrderField;
(function(PostOrderField) {
    PostOrderField[/** Order posts by content_name */ "ContentName"] = "CONTENT_NAME";
    PostOrderField[/** Order posts by course_name */ "CourseName"] = "COURSE_NAME";
    PostOrderField[/** Order posts by created_at */ "CreatedAt"] = "CREATED_AT";
    PostOrderField[/** Order posts by last_interaction_at */ "LastInteractionAt"] = "LAST_INTERACTION_AT";
    PostOrderField[/** Order posts by pinned_at */ "PinnedAt"] = "PINNED_AT";
    PostOrderField[/** Order posts by reply_count */ "ReplyCount"] = "REPLY_COUNT";
    PostOrderField[/** Order posts by title */ "Title"] = "TITLE";
    PostOrderField[/** Order posts by trending_score */ "TrendingScore"] = "TRENDING_SCORE";
    PostOrderField[/** Order posts by updated_at */ "UpdatedAt"] = "UPDATED_AT";
})(PostOrderField || (PostOrderField = {}));
var PostReactionType;
(function(PostReactionType) {
    PostReactionType[/** Like reaction type */ "Like"] = "like";
})(PostReactionType || (PostReactionType = {}));
var PresentationStatusEnum;
(function(PresentationStatusEnum) {
    PresentationStatusEnum[/** Complete status type */ "Complete"] = "complete";
    PresentationStatusEnum[/** Error status type */ "Error"] = "error";
    PresentationStatusEnum[/** Processing status type */ "Processing"] = "processing";
})(PresentationStatusEnum || (PresentationStatusEnum = {}));
var PriceTypes;
(function(PriceTypes) {
    PriceTypes[/** Free course */ "Free"] = "Free";
    PriceTypes[/** One time payment */ "OneTime"] = "OneTime";
    PriceTypes[/** Payment plan */ "PaymentPlan"] = "PaymentPlan";
    PriceTypes[/** Subscription plan */ "Subscription"] = "Subscription";
})(PriceTypes || (PriceTypes = {}));
var ProductLicenseEventSourceEnum;
(function(ProductLicenseEventSourceEnum) {
    ProductLicenseEventSourceEnum[/** product license create/update bulk_enrollment event */ "BulkEnrollment"] = "BULK_ENROLLMENT";
    ProductLicenseEventSourceEnum[/** product license create/update tenant_admin event */ "TenantAdmin"] = "TENANT_ADMIN";
})(ProductLicenseEventSourceEnum || (ProductLicenseEventSourceEnum = {}));
var ProductSortField;
(function(ProductSortField) {
    ProductSortField[/** Sort by the associated product page's edited_at date from within the active theme */ "EditedAt"] = "EDITED_AT";
    ProductSortField[/** Sort by the associate product's type value */ "Type"] = "TYPE";
    ProductSortField[/** Sort by the associate product's updated_at value */ "UpdatedAt"] = "UPDATED_AT";
})(ProductSortField || (ProductSortField = {}));
var ProductStatus;
(function(ProductStatus) {
    ProductStatus[/** Draft */ "Draft"] = "draft";
    ProductStatus[/** Pending approval */ "PendingApproval"] = "pending_approval";
    ProductStatus[/** Pre-order */ "Presell"] = "presell";
    ProductStatus[/** Published */ "Published"] = "published";
})(ProductStatus || (ProductStatus = {}));
var ProductTypes;
(function(ProductTypes) {
    ProductTypes[/** A bundle */ "Bundle"] = "Bundle";
    ProductTypes[/** A community */ "Community"] = "Community";
    ProductTypes[/** A course */ "Course"] = "Course";
    ProductTypes[/** A digital download */ "DigitalDownload"] = "DigitalDownload";
    ProductTypes[/** A live event */ "LiveEvent"] = "LiveEvent";
})(ProductTypes || (ProductTypes = {}));
var PromptStatusEnum;
(function(PromptStatusEnum) {
    PromptStatusEnum[/** Completed */ "Completed"] = "Completed";
    PromptStatusEnum[/** Failed */ "Failed"] = "Failed";
    PromptStatusEnum[/** In Progress */ "InProgress"] = "InProgress";
})(PromptStatusEnum || (PromptStatusEnum = {}));
var PromptTypeEnum;
(function(PromptTypeEnum) {
    PromptTypeEnum[/** Generate Course Outline */ "GenerateCourseOutline"] = "generate_course_outline";
    PromptTypeEnum[/** Generate Lead Capture */ "GenerateFunnelPageContent"] = "generate_funnel_page_content";
    PromptTypeEnum[/** Generate Quiz */ "GenerateQuiz"] = "generate_quiz";
    PromptTypeEnum[/** Regenerate Text Content */ "RegenerateTextContent"] = "regenerate_text_content";
})(PromptTypeEnum || (PromptTypeEnum = {}));
var PublicationStatusTypes;
(function(PublicationStatusTypes) {
    PublicationStatusTypes[/** A draft product */ "Draft"] = "draft";
    PublicationStatusTypes[/** A pre order product */ "Presell"] = "presell";
    PublicationStatusTypes[/** A published product */ "Published"] = "published";
})(PublicationStatusTypes || (PublicationStatusTypes = {}));
var QuestionTypeEnum;
(function(QuestionTypeEnum) {
    QuestionTypeEnum[/** Checkbox question type */ "Checkbox"] = "checkbox";
    QuestionTypeEnum[/** Radio question type */ "Radio"] = "radio";
})(QuestionTypeEnum || (QuestionTypeEnum = {}));
var QuizTypeEnum;
(function(QuizTypeEnum) {
    QuizTypeEnum[/** Pass Fail quiz type */ "PassFail"] = "pass_fail";
    QuizTypeEnum[/** Simple quiz type */ "Simple"] = "simple";
})(QuizTypeEnum || (QuizTypeEnum = {}));
var ReasonType;
(function(ReasonType) {
    ReasonType[/** Filter by reason */ "Functionality"] = "FUNCTIONALITY";
    ReasonType[/** Filter by reason */ "Other"] = "OTHER";
    ReasonType[/** Filter by reason */ "Price"] = "PRICE";
    ReasonType[/** Filter by reason */ "Security"] = "SECURITY";
    ReasonType[/** Filter by reason */ "Usability"] = "USABILITY";
})(ReasonType || (ReasonType = {}));
var RecurrenceTypeEnum;
(function(RecurrenceTypeEnum) {
    RecurrenceTypeEnum["Day"] = "Day";
    RecurrenceTypeEnum["Month"] = "Month";
    RecurrenceTypeEnum["Week"] = "Week";
})(RecurrenceTypeEnum || (RecurrenceTypeEnum = {}));
var RedirectSitePageView;
(function(RedirectSitePageView) {
    RedirectSitePageView["CollectionsLandingPage"] = "collections_landing_page";
    RedirectSitePageView["ComingSoonPage"] = "coming_soon_page";
    RedirectSitePageView["HomeLandingPage"] = "home_landing_page";
    RedirectSitePageView["SignInPage"] = "sign_in_page";
    RedirectSitePageView["SignUpPage"] = "sign_up_page";
    RedirectSitePageView["StudentDashboard"] = "student_dashboard";
})(RedirectSitePageView || (RedirectSitePageView = {}));
var RefundReason;
(function(RefundReason) {
    RefundReason[/** duplicate refund */ "Duplicate"] = "duplicate";
    RefundReason[/** fraudulent refund */ "Fraudulent"] = "fraudulent";
    RefundReason[/** refund requested by customer */ "RequestedByCustomer"] = "requested_by_customer";
})(RefundReason || (RefundReason = {}));
var ReplyOrderField;
(function(ReplyOrderField) {
    ReplyOrderField[/** Order posts by content */ "Content"] = "CONTENT";
    ReplyOrderField[/** Order posts by created_at */ "CreatedAt"] = "CREATED_AT";
    ReplyOrderField[/** Order posts by updated_at */ "UpdatedAt"] = "UPDATED_AT";
})(ReplyOrderField || (ReplyOrderField = {}));
var ReportingOrderField;
(function(ReportingOrderField) {
    ReportingOrderField[/** order by completedAt date */ "CompletionDate"] = "completionDate";
    ReportingOrderField[/** order by content name date */ "ContentName"] = "contentName";
    ReportingOrderField[/** order by content type */ "ContentType"] = "contentType";
    ReportingOrderField[/** order by completedAt date */ "CourseName"] = "courseName";
    ReportingOrderField[/** order by passing grade (for quiz/surveys) */ "PassingGrade"] = "passingGrade";
    ReportingOrderField[/** order by student grade (for quiz/surveys) */ "StudentGrade"] = "studentGrade";
})(ReportingOrderField || (ReportingOrderField = {}));
var ResponseStatus;
(function(ResponseStatus) {
    ResponseStatus[/** Process failed */ "Failed"] = "FAILED";
    ResponseStatus[/** Process partially successful due to some ids returned with errors */ "PartialSuccess"] = "PARTIAL_SUCCESS";
    ResponseStatus[/** Process successfully executed */ "Success"] = "SUCCESS";
})(ResponseStatus || (ResponseStatus = {}));
var SitePageOrderField;
(function(SitePageOrderField) {
    SitePageOrderField[/** Order user site pages by created_at */ "CreatedAt"] = "CREATED_AT";
    SitePageOrderField[/** Order user site pages by name */ "Name"] = "NAME";
    SitePageOrderField[/** Order user site pages by updated_at */ "UpdatedAt"] = "UPDATED_AT";
})(SitePageOrderField || (SitePageOrderField = {}));
var SitePageType;
(function(SitePageType) {
    SitePageType[/** Custom theme page */ "CustomPage"] = "CUSTOM_PAGE";
    SitePageType[/** Default theme page */ "CustomSiteThemeView"] = "CUSTOM_SITE_THEME_VIEW";
    SitePageType[/** Product theme page */ "Product"] = "PRODUCT";
    SitePageType[/** Site template page */ "SitePage"] = "SITE_PAGE";
})(SitePageType || (SitePageType = {}));
var StateType;
(function(StateType) {
    StateType[/** Filter apps by approved */ "Approved"] = "APPROVED";
    StateType[/** Filter apps by draft */ "Draft"] = "DRAFT";
    StateType[/** Filter apps by suspended */ "Suspended"] = "SUSPENDED";
})(StateType || (StateType = {}));
var StatusEnum;
(function(StatusEnum) {
    StatusEnum[/** Complete, fulfilled order */ "Complete"] = "Complete";
    StatusEnum[/** Incomplete, unfulfilled order */ "Incomplete"] = "Incomplete";
    StatusEnum[/** Processing, processing order */ "Processing"] = "Processing";
})(StatusEnum || (StatusEnum = {}));
var StatusTypeEnum;
(function(StatusTypeEnum) {
    StatusTypeEnum[/** Approved status */ "Approved"] = "Approved";
    StatusTypeEnum[/** Pending status */ "Pending"] = "Pending";
    StatusTypeEnum[/** Rejected status */ "Rejected"] = "Rejected";
})(StatusTypeEnum || (StatusTypeEnum = {}));
var StudentNotificationSlugType;
(function(StudentNotificationSlugType) {
    StudentNotificationSlugType[/** Community Welcome Email */ "CommunityWelcomeEmail"] = "community_welcome_email";
    StudentNotificationSlugType[/** Discussion replies */ "DiscussionReply"] = "discussion_reply";
    StudentNotificationSlugType[/** Incomplete purchase reminder */ "IncompletePurchaseReminder"] = "incomplete_purchase_reminder";
    StudentNotificationSlugType[/** Receipts */ "PurchaseReceipt"] = "purchase_receipt";
    StudentNotificationSlugType[/** Upcoming payment reminder */ "UpcomingPaymentReminder"] = "upcoming_payment_reminder";
    StudentNotificationSlugType[/** Weekly reminder */ "WeeklyEmailReminders"] = "weekly_email_reminders";
    StudentNotificationSlugType[/** Site welcome */ "WelcomeEmail"] = "welcome_email";
    StudentNotificationSlugType[/** Site welcome (SSO) */ "WelcomeEmailFromSso"] = "welcome_email_from_sso";
})(StudentNotificationSlugType || (StudentNotificationSlugType = {}));
var SubmissionOrderField;
(function(SubmissionOrderField) {
    SubmissionOrderField[/** order submissions by submitter's full name */ "ChapterName"] = "chapterName";
    SubmissionOrderField[/** order submissions by submitter's full name */ "CourseName"] = "courseName";
    SubmissionOrderField[/** order submissions by created at */ "CreatedAt"] = "createdAt";
    SubmissionOrderField[/** order submissions by submitter's email */ "Email"] = "email";
    SubmissionOrderField[/** order submissions by file name */ "FileName"] = "fileName";
    SubmissionOrderField[/** order submissions by file size */ "FileSize"] = "fileSize";
    SubmissionOrderField[/** order submissions by submitter's full name */ "LessonName"] = "lessonName";
    SubmissionOrderField[/** order submissions by reviewed at */ "ReviewedAt"] = "reviewedAt";
    SubmissionOrderField[/** order submissions by status */ "Status"] = "status";
    SubmissionOrderField[/** order submissions by updated at */ "UpdatedAt"] = "updatedAt";
    SubmissionOrderField[/** order submissions by submitter's full name */ "UserFullName"] = "userFullName";
})(SubmissionOrderField || (SubmissionOrderField = {}));
var SubmissionStatus;
(function(SubmissionStatus) {
    SubmissionStatus[/** Submission status approved */ "Approved"] = "approved";
    SubmissionStatus[/** Submission status pending */ "Pending"] = "pending";
    SubmissionStatus[/** Submission status rejected */ "Rejected"] = "rejected";
})(SubmissionStatus || (SubmissionStatus = {}));
var SurveyQuestionTypeEnum;
(function(SurveyQuestionTypeEnum) {
    SurveyQuestionTypeEnum[/** Checkbox question type */ "Checkbox"] = "checkbox";
    SurveyQuestionTypeEnum[/** Freetext question type */ "Freetext"] = "freetext";
    SurveyQuestionTypeEnum[/** Radio question type */ "Radio"] = "radio";
    SurveyQuestionTypeEnum[/** Rating question type */ "Rating"] = "rating";
    SurveyQuestionTypeEnum[/** Scale question type */ "Scale"] = "scale";
})(SurveyQuestionTypeEnum || (SurveyQuestionTypeEnum = {}));
var TaxRegistrationStatus;
(function(TaxRegistrationStatus) {
    TaxRegistrationStatus[/** tax not registered */ "NotRegistered"] = "not_registered";
    TaxRegistrationStatus[/** tax registered */ "Registered"] = "registered";
})(TaxRegistrationStatus || (TaxRegistrationStatus = {}));
var ThemeInstallationOrderFieldFilter;
(function(ThemeInstallationOrderFieldFilter) {
    ThemeInstallationOrderFieldFilter[/** Order theme installations by installed_at */ "InstalledAt"] = "INSTALLED_AT";
})(ThemeInstallationOrderFieldFilter || (ThemeInstallationOrderFieldFilter = {}));
var ThemeLibraryItemVersionStyleOrderFieldFilter;
(function(ThemeLibraryItemVersionStyleOrderFieldFilter) {
    ThemeLibraryItemVersionStyleOrderFieldFilter[/** Order styles by id */ "Id"] = "ID";
    ThemeLibraryItemVersionStyleOrderFieldFilter[/** Order styles by name */ "Name"] = "NAME";
})(ThemeLibraryItemVersionStyleOrderFieldFilter || (ThemeLibraryItemVersionStyleOrderFieldFilter = {}));
var ThemePresetOrderFieldFilter;
(function(ThemePresetOrderFieldFilter) {
    ThemePresetOrderFieldFilter[/** Order presets by description */ "Description"] = "DESCRIPTION";
    ThemePresetOrderFieldFilter[/** Order presets by id */ "Id"] = "ID";
    ThemePresetOrderFieldFilter[/** Order presets by slug */ "Slug"] = "SLUG";
    ThemePresetOrderFieldFilter[/** Order presets by title */ "Title"] = "TITLE";
})(ThemePresetOrderFieldFilter || (ThemePresetOrderFieldFilter = {}));
var Transaction;
(function(Transaction) {
    Transaction[/** When a transaction is a single payment */ "Payment"] = "PAYMENT";
    Transaction[/** When a transaction is a full or a partial refund */ "Refund"] = "REFUND";
})(Transaction || (Transaction = {}));
var TransactionPricing;
(function(TransactionPricing) {
    TransactionPricing[/** One time payment */ "OneTime"] = "ONE_TIME";
    TransactionPricing[/** Payment plan */ "PaymentPlan"] = "PAYMENT_PLAN";
    TransactionPricing[/** Subscription plan */ "Subscription"] = "SUBSCRIPTION";
})(TransactionPricing || (TransactionPricing = {}));
var TransactionStatus;
(function(TransactionStatus) {
    TransactionStatus[/** There was an issue with this transaction */ "Failed"] = "FAILED";
    TransactionStatus[/** This transaction represents a total refund of the original order */ "FullyRefunded"] = "FULLY_REFUNDED";
    TransactionStatus[/** This transaction represents a partial refund on the original order */ "PartiallyRefunded"] = "PARTIALLY_REFUNDED";
    TransactionStatus[/** This transaction has succeeded */ "Succeeded"] = "SUCCEEDED";
    TransactionStatus[/** This transaction represents a tax-only refund on the original order */ "TaxRefunded"] = "TAX_REFUNDED";
})(TransactionStatus || (TransactionStatus = {}));
var UserContentOrderField;
(function(UserContentOrderField) {
    UserContentOrderField[/** order user contents by completedAt date */ "CompletedAt"] = "completedAt";
})(UserContentOrderField || (UserContentOrderField = {}));
var UserEnrollmentStatus;
(function(UserEnrollmentStatus) {
    UserEnrollmentStatus[/** User's completed enrollments in course */ "Completed"] = "COMPLETED";
    UserEnrollmentStatus[/** User's in progress enrollments in course */ "Inprogress"] = "INPROGRESS";
    UserEnrollmentStatus[/** User's not started enrollments in course */ "Notstarted"] = "NOTSTARTED";
})(UserEnrollmentStatus || (UserEnrollmentStatus = {}));
var UserOrderField;
(function(UserOrderField) {
    UserOrderField[/** Order users by country */ "Country"] = "COUNTRY";
    UserOrderField[/** Order users by created_at */ "CreatedAt"] = "CREATED_AT";
    UserOrderField[/** Order users by current_sign_in_at */ "CurrentSignInAt"] = "CURRENT_SIGN_IN_AT";
    UserOrderField[/** Order users by email */ "Email"] = "EMAIL";
    UserOrderField[/** Order users by external_source */ "ExternalSource"] = "EXTERNAL_SOURCE";
    UserOrderField[/** Order users by first_name */ "FirstName"] = "FIRST_NAME";
    UserOrderField[/** Order users by full_name */ "FullName"] = "FULL_NAME";
    UserOrderField[/** Order users by id */ "Id"] = "ID";
    UserOrderField[/** Order users by ip_address */ "IpAddress"] = "IP_ADDRESS";
    UserOrderField[/** Order users by last_name */ "LastName"] = "LAST_NAME";
    UserOrderField[/** Order users by postal_code */ "PostalCode"] = "POSTAL_CODE";
    UserOrderField[/** Order users by referral_code */ "ReferralCode"] = "REFERRAL_CODE";
    UserOrderField[/** Order users by sign_in_count */ "SignInCount"] = "SIGN_IN_COUNT";
    UserOrderField[/** Order users by state */ "State"] = "STATE";
    UserOrderField[/** Order users by total_spent_in_cents */ "TotalSpentInCents"] = "TOTAL_SPENT_IN_CENTS";
})(UserOrderField || (UserOrderField = {}));
var UserQuizOrderField;
(function(UserQuizOrderField) {
    UserQuizOrderField[/** order user quizzes by completedAt date */ "CompletedAt"] = "completedAt";
})(UserQuizOrderField || (UserQuizOrderField = {}));
var UserRole;
(function(UserRole) {
    UserRole[/** User who is an affiliate */ "Affiliate"] = "AFFILIATE";
    UserRole[/** User who admins a course */ "CourseAdmin"] = "COURSE_ADMIN";
    UserRole[/** User who admins a group */ "GroupAnalyst"] = "GROUP_ANALYST";
    UserRole[/** User who owns the site */ "Owner"] = "OWNER";
    UserRole[/** Partner managing the site */ "Partner"] = "PARTNER";
    UserRole[/** Users who are product payee */ "ProductPayee"] = "PRODUCT_PAYEE";
    UserRole[/** User who admins the site */ "SiteAdmin"] = "SITE_ADMIN";
    UserRole[/** Students users */ "Student"] = "STUDENT";
})(UserRole || (UserRole = {}));
var UserSurveyOrderField;
(function(UserSurveyOrderField) {
    UserSurveyOrderField[/** order user surveys by completedAt date */ "CompletedAt"] = "completedAt";
})(UserSurveyOrderField || (UserSurveyOrderField = {}));
var VideoOrderField;
(function(VideoOrderField) {
    VideoOrderField[/** order videos by created at */ "CreatedAt"] = "createdAt";
    VideoOrderField[/** order videos by length */ "DurationInSeconds"] = "durationInSeconds";
    VideoOrderField[/** order videos by engagement */ "Engagement"] = "engagement";
    VideoOrderField[/** order videos by file name */ "FileName"] = "fileName";
    VideoOrderField[/** order videos by hours played */ "Hours"] = "hours";
    VideoOrderField[/** order videos by file size */ "HumanReadableFileSize"] = "humanReadableFileSize";
    VideoOrderField[/** order videos by play rate */ "PlayRate"] = "playRate";
    VideoOrderField[/** order videos by number of plays */ "Plays"] = "plays";
    VideoOrderField[/** order videos by updated at */ "UpdatedAt"] = "updatedAt";
    VideoOrderField[/** order videos by number of views */ "Views"] = "views";
    VideoOrderField[/** order videos by number of visitors */ "Visitors"] = "visitors";
})(VideoOrderField || (VideoOrderField = {}));
var WebinarProviderEnum;
(function(WebinarProviderEnum) {
    WebinarProviderEnum[/** zoom meeting type */ "Zoom"] = "zoom";
})(WebinarProviderEnum || (WebinarProviderEnum = {}));
var ZoomTypeEnum;
(function(ZoomTypeEnum) {
    ZoomTypeEnum[/** zoom meeting type */ "Meeting"] = "meeting";
    ZoomTypeEnum[/** zoom webinar type */ "Webinar"] = "webinar";
})(ZoomTypeEnum || (ZoomTypeEnum = {}));
var ZoomUserOrderFieldFilter;
(function(ZoomUserOrderFieldFilter) {
    ZoomUserOrderFieldFilter[/** order Zoom users by email */ "Email"] = "EMAIL";
    ZoomUserOrderFieldFilter[/** order Zoom users by name */ "Name"] = "NAME";
    ZoomUserOrderFieldFilter[/** order Zoom users by status */ "Status"] = "STATUS";
})(ZoomUserOrderFieldFilter || (ZoomUserOrderFieldFilter = {}));
var ZoomUserStatus;
(function(ZoomUserStatus) {
    ZoomUserStatus[/** An active zoom user */ "Active"] = "ACTIVE";
    ZoomUserStatus[/** A deactivated zoom user */ "Inactive"] = "INACTIVE";
    ZoomUserStatus[/** A pending zoom user */ "Pending"] = "PENDING";
})(ZoomUserStatus || (ZoomUserStatus = {}));
var EventFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EventFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "meetingUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "location"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var LiveEventsEdgesNodeFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "LiveEventsEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interestedUsers"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isInterested"
                        }
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "EventFields"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EventFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "meetingUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "location"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var LiveEventsEdgesFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "LiveEventsEdgesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEventEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "LiveEventsEdgesNodeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EventFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "meetingUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "location"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "LiveEventsEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interestedUsers"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isInterested"
                        }
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "EventFields"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var InterestedUsersEdgesNodeFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterestedUsersEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var InterestedUsersEdgesFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterestedUsersEdgesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InterestedUsersEdgesNodeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterestedUsersEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var EventInterestedUsersFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EventInterestedUsersFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isInterested"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interestedUsers"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfUsers"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "after"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "endCursor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "hasNextPage"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "InterestedUsersEdgesFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterestedUsersEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterestedUsersEdgesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InterestedUsersEdgesNodeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CourseFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CourseFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Course"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cardImageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "enrollmentsCount"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "resumeCourseUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "percentageCompleted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPrivate"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isHidden"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            }
        }, 
    ]
};
var ProductsEdgeFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductsEdgeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ProductEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "publishedStatus"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "productable"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "__typename"
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "Course"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "CourseFields"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communityProductRelation"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "relation"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "__typename"
                                                            }
                                                        },
                                                        {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                                kind: "NamedType",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "CommunitySpace"
                                                                }
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "community"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "name"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CourseFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Course"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cardImageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "enrollmentsCount"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "resumeCourseUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "percentageCompleted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPrivate"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isHidden"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            }
        }, 
    ]
};
var ProductsFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ProductConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ProductsEdgeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CourseFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Course"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cardImageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "enrollmentsCount"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "resumeCourseUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "percentageCompleted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPrivate"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isHidden"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductsEdgeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ProductEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "publishedStatus"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "productable"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "__typename"
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "Course"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "CourseFields"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communityProductRelation"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "relation"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "__typename"
                                                            }
                                                        },
                                                        {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                                kind: "NamedType",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "CommunitySpace"
                                                                }
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "community"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "name"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SpaceFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SpaceFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunitySpace"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "iconName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "position"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "s3UploadPath"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isExclusive"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "posts"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communityProductRelation"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isCoursesToCommunitiesEnabled"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "product"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SectionFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SectionFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunitySection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpaces"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "communitySpaces",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "SpaceFields"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "posts"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "id"
                                                                                                }
                                                                                            }, 
                                                                                        ]
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalCount"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SpaceFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunitySpace"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "iconName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "position"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "s3UploadPath"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isExclusive"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "posts"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communityProductRelation"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isCoursesToCommunitiesEnabled"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "product"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CommunityEdgesNodeUserFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesNodeUserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CommunityEdgesNodeFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunityUser"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "permissions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        }, 
                                    ]
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "CommunityEdgesNodeUserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesNodeUserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CommunityEdgesFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunityUserEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "CommunityEdgesNodeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesNodeUserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunityUser"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "permissions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        }, 
                                    ]
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "CommunityEdgesNodeUserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UserEnrollmentFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserEnrollmentFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "EnrollmentConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "completedAt"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "course"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "cardImageUrl"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "resumeCourseUrl"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "landingPageUrl"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PostAttachmentsFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var MentionedUsersFieldFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UserFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PostFieldsWithUserPermissionsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFieldsWithUserPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "permissions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        }, 
                                    ]
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PostFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UserFieldsWithPermissionsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFieldsWithPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "permissions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceType"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "Community"
                                }
                            }, 
                        ]
                    }, 
                ]
            }
        }, 
    ]
};
var ReplyFieldsWithUserPermissionsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFieldsWithUserPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFieldsWithPermissions"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFieldsWithPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "permissions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceType"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "Community"
                                }
                            }, 
                        ]
                    }, 
                ]
            }
        }, 
    ]
};
var ReplyFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ReplyEdgeNodeReliesFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyEdgeNodeReliesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ReplyConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasPreviousPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "startCursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalCount"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ReplyEdgeFieldsFragmentDoc = {
    kind: "Document",
    definitions: [
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyEdgeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "ReplyFieldsWithUserPermissions"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "last"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numOfNestedReplies"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "field"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "CREATED_AT"
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "direction"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "ASC"
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ReplyEdgeNodeReliesFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFieldsWithPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "permissions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceType"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "Community"
                                }
                            }, 
                        ]
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFieldsWithUserPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFieldsWithPermissions"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyEdgeNodeReliesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ReplyConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasPreviousPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "startCursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalCount"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateAccountNotificationDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateAccountNotification"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateAccountNotificationInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateAccountNotification"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateLiveEventDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateLiveEvent"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateLiveEventInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createLiveEvent"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvent"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DuplicateLiveEventDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DuplicateLiveEvent"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "DuplicateLiveEventInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "duplicateLiveEvent"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvent"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateLiveEventDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateLiveEvent"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateLiveEventInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateLiveEvent"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvent"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeleteLiveEventDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteLiveEvent"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "DeleteLiveEventInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteLiveEvent"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateAttendanceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateAttendance"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateAttendanceInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createAttendance"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvent"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isInterested"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "interestedUsers"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeleteAttendanceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteAttendance"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "DeleteAttendanceInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteAttendance"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvent"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isInterested"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "interestedUsers"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var LiveEventsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "LiveEvents"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "eventStatus"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "EventStatusTypes"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "eventSourceId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfEvents"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "startDateTime"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "DateTime"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "endDateTime"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "DateTime"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sortDirection"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "OrderDirection"
                        }
                    },
                    defaultValue: {
                        kind: "EnumValue",
                        value: "ASC"
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "site"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvents"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "eventSourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "eventSourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "eventSourceId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "numberOfEvents"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "field"
                                                        },
                                                        value: {
                                                            kind: "EnumValue",
                                                            value: "start_time"
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "direction"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "sortDirection"
                                                            }
                                                        }
                                                    }, 
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "eventStatus"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "eventStatus"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "startTime"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startDateTime"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "endTime"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "endDateTime"
                                                            }
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "totalCount"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "pageInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasNextPage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "endCursor"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "LiveEventsEdgesFields"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EventFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "meetingUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "location"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "LiveEventsEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interestedUsers"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isInterested"
                        }
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "EventFields"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "LiveEventsEdgesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEventEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "LiveEventsEdgesNodeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var LiveEventDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "LiveEvent"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "eventId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfUsers"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    },
                    defaultValue: {
                        kind: "IntValue",
                        value: "5"
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "endCursor"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "site"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvent"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "eventId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "EventFields"
                                                }
                                            },
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "EventInterestedUsersFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterestedUsersEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InterestedUsersEdgesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InterestedUsersEdgesNodeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EventFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "meetingUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "location"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EventInterestedUsersFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "LiveEvent"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isInterested"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "interestedUsers"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfUsers"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "after"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "pageInfo"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "endCursor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "hasNextPage"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "InterestedUsersEdgesFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var LiveEventsCountDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "LiveEventsCount"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "eventSourceId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "site"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "liveEvents"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "eventSourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "eventSourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "eventSourceId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "totalCount"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreatePostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreatePost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "discussionableId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "spaceId"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ID"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "postAttachment"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "PostAttachmentInput"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "mentionedUserIds"
                        }
                    },
                    type: {
                        kind: "ListType",
                        type: {
                            kind: "NonNullType",
                            type: {
                                kind: "NamedType",
                                name: {
                                    kind: "Name",
                                    value: "ID"
                                }
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createPost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "discussionableId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "discussionableId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "title"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "title"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "content"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "content"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "communitySpaceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "spaceId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "postAttachmentInput"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "postAttachment"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "mentionedUserIds"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "mentionedUserIds"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var EditPostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "EditPost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "EditPostInput"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editPost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeletePostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeletePost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deletePost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var FollowPostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "FollowPost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "followPost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UnfollowPostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UnfollowPost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "unfollowPost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PinPostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "PinPost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinPost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UnpinPostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UnpinPost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "unpinPost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ToggleReactionOnPostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ToggleReactionOnPost"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "reactionType"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "PostReactionType"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "toggleReactionOnPost"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "reactionType"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "reactionType"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PostListDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "PostList"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numOfPosts"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "endCursor"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "postOrderField"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "PostOrderField"
                        }
                    },
                    defaultValue: {
                        kind: "EnumValue",
                        value: "PINNED_AT"
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filter"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "PostFilter"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "posts"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "numOfPosts"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "after"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "endCursor"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "filter"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "field"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "postOrderField"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "direction"
                                                        },
                                                        value: {
                                                            kind: "EnumValue",
                                                            value: "DESC"
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "cursor"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "PostFieldsWithUserPermissions"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "pageInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasPreviousPage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "hasNextPage"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startCursor"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "endCursor"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFieldsWithUserPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "permissions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        }, 
                                    ]
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PostDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Post"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "postId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "postId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFieldsWithUserPermissions"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFieldsWithUserPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "permissions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        }, 
                                    ]
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CommunityProductRelationsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "CommunityProductRelations"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "relatableId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "isModerator"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "relatableType"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communityProductRelations"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "relatableId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "relatableId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "relatableType"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "relatableType"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "cursor"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "product"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "slug"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "productable"
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "__typename"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                kind: "InlineFragment",
                                                                                                typeCondition: {
                                                                                                    kind: "NamedType",
                                                                                                    name: {
                                                                                                        kind: "Name",
                                                                                                        value: "Course"
                                                                                                    }
                                                                                                },
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "FragmentSpread",
                                                                                                            name: {
                                                                                                                kind: "Name",
                                                                                                                value: "CourseFields"
                                                                                                            }
                                                                                                        }, 
                                                                                                    ]
                                                                                                }
                                                                                            }, 
                                                                                        ]
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CourseFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Course"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cardImageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "enrollmentsCount"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "resumeCourseUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "percentageCompleted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPrivate"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isHidden"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            }
        }, 
    ]
};
var ProductsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Products"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "isModerator"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "site"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "products"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "publicationStatus"
                                                        },
                                                        value: {
                                                            kind: "ListValue",
                                                            values: [
                                                                {
                                                                    kind: "EnumValue",
                                                                    value: "published"
                                                                }, 
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "type"
                                                        },
                                                        value: {
                                                            kind: "EnumValue",
                                                            value: "Course"
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ProductsFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CourseFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Course"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cardImageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "enrollmentsCount"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "resumeCourseUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "percentageCompleted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPrivate"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isHidden"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isModerator"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ]
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductsEdgeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ProductEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "publishedStatus"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "productable"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "__typename"
                                                }
                                            },
                                            {
                                                kind: "InlineFragment",
                                                typeCondition: {
                                                    kind: "NamedType",
                                                    name: {
                                                        kind: "Name",
                                                        value: "Course"
                                                    }
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "CourseFields"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communityProductRelation"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "relation"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "__typename"
                                                            }
                                                        },
                                                        {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                                kind: "NamedType",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "CommunitySpace"
                                                                }
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "name"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "community"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "name"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ProductsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ProductConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ProductsEdgeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateReplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateReply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "discussionableId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "parentPostId"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ID"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "parentReplyId"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "ID"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "postAttachmentInput"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "PostAttachmentInput"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "mentionedUserIds"
                        }
                    },
                    type: {
                        kind: "ListType",
                        type: {
                            kind: "NonNullType",
                            type: {
                                kind: "NamedType",
                                name: {
                                    kind: "Name",
                                    value: "ID"
                                }
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createReply"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "discussionableId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "discussionableId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "content"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "content"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "parentPostId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "parentPostId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "parentReplyId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "parentReplyId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "postAttachmentInput"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "postAttachmentInput"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "mentionedUserIds"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "mentionedUserIds"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var EditReplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "EditReply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "EditReplyInput"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editReply"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeleteReplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteReply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteReply"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ToggleReactionOnReplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ToggleReactionOnReply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "reactionType"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "PostReactionType"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "toggleReactionOnReply"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "reactionType"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "reactionType"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var FollowReplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "FollowReply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "followReply"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UnfollowReplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UnfollowReply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "unfollowReply"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ReplyDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Reply"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "postId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "startCursor"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numOfNestedReplies"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "postId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "PostFields"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                arguments: [
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "orderBy"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "field"
                                                                    },
                                                                    value: {
                                                                        kind: "EnumValue",
                                                                        value: "CREATED_AT"
                                                                    }
                                                                },
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "direction"
                                                                    },
                                                                    value: {
                                                                        kind: "EnumValue",
                                                                        value: "ASC"
                                                                    }
                                                                }, 
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "before"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startCursor"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "last"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "numOfNestedReplies"
                                                            }
                                                        }
                                                    }, 
                                                ],
                                                directives: [
                                                    {
                                                        kind: "Directive",
                                                        name: {
                                                            kind: "Name",
                                                            value: "connection"
                                                        },
                                                        arguments: [
                                                            {
                                                                kind: "Argument",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "key"
                                                                },
                                                                value: {
                                                                    kind: "StringValue",
                                                                    value: "replies",
                                                                    block: false
                                                                }
                                                            }, 
                                                        ]
                                                    }, 
                                                ],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "edges"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "cursor"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "node"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "FragmentSpread",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "ReplyFields"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "pageInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "hasPreviousPage"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "hasNextPage"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "startCursor"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "endCursor"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Post"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pinnedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpace"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "iconName"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PostAttachmentsFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "replies",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "nodes"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var RepliesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Replies"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "postId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numOfReplies"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numOfNestedReplies"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "startCursor"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "post"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "postId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                arguments: [
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "last"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "numOfReplies"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "before"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startCursor"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "orderBy"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "field"
                                                                    },
                                                                    value: {
                                                                        kind: "EnumValue",
                                                                        value: "CREATED_AT"
                                                                    }
                                                                },
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "direction"
                                                                    },
                                                                    value: {
                                                                        kind: "EnumValue",
                                                                        value: "ASC"
                                                                    }
                                                                }, 
                                                            ]
                                                        }
                                                    }, 
                                                ],
                                                directives: [
                                                    {
                                                        kind: "Directive",
                                                        name: {
                                                            kind: "Name",
                                                            value: "connection"
                                                        },
                                                        arguments: [
                                                            {
                                                                kind: "Argument",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "key"
                                                                },
                                                                value: {
                                                                    kind: "StringValue",
                                                                    value: "replies",
                                                                    block: false
                                                                }
                                                            }, 
                                                        ]
                                                    }, 
                                                ],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "edges"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "cursor"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "node"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "FragmentSpread",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "ReplyEdgeFields"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "pageInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "hasPreviousPage"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "hasNextPage"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "startCursor"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "endCursor"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFieldsWithPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "permissions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceId"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "resourceType"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "Community"
                                }
                            }, 
                        ]
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFieldsWithUserPermissions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFieldsWithPermissions"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyEdgeNodeReliesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ReplyConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "ReplyFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasPreviousPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "startCursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalCount"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyEdgeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "ReplyFieldsWithUserPermissions"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "replies"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "last"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numOfNestedReplies"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "field"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "CREATED_AT"
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "direction"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "ASC"
                                            }
                                        }, 
                                    ]
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "ReplyEdgeNodeReliesFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var NestedRepliesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "NestedReplies"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "parentReplyId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numOfReplies"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "startCursor"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfReactions"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "parentReplyId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "replies"
                                                },
                                                arguments: [
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "last"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "numOfReplies"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "before"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startCursor"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "orderBy"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "field"
                                                                    },
                                                                    value: {
                                                                        kind: "EnumValue",
                                                                        value: "CREATED_AT"
                                                                    }
                                                                },
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "direction"
                                                                    },
                                                                    value: {
                                                                        kind: "EnumValue",
                                                                        value: "ASC"
                                                                    }
                                                                }, 
                                                            ]
                                                        }
                                                    }, 
                                                ],
                                                directives: [
                                                    {
                                                        kind: "Directive",
                                                        name: {
                                                            kind: "Name",
                                                            value: "connection"
                                                        },
                                                        arguments: [
                                                            {
                                                                kind: "Argument",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "key"
                                                                },
                                                                value: {
                                                                    kind: "StringValue",
                                                                    value: "replies",
                                                                    block: false
                                                                }
                                                            }, 
                                                        ]
                                                    }, 
                                                ],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "edges"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "cursor"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "node"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "FragmentSpread",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "ReplyFields"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "pageInfo"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "hasPreviousPage"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "hasNextPage"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "startCursor"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "endCursor"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "totalCount"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MentionedUsersField"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "UserConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "fullName"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "avatarUrl"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "firstName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "avatarUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ReplyFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Reply"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "content"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "editedAt"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isFollowing"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postReactions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "numberOfReactions"
                                    }
                                }
                            }, 
                        ],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "postReactions",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "user"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "fullName"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "mentionedUsers"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "mentionedUsers",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MentionedUsersField"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "UserFields"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "hasReacted"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "postAttachments"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "altText"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "attachmentType"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fileSizeInBytes"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "url"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ReplyDepthDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "ReplyDepth"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "reply"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "depth"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "parentPost"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var PostSearchDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "PostSearch"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "searchTerm"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "searchAuthor"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "searchableCommunityPosts"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "searchTerm"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "searchTerm"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "searchAuthor"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "searchAuthor"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "cursor"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "depth"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "title"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "content"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "createdAt"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "editedAt"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "rootPost"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "title"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "communitySpace"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "name"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "iconName"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "postAttachments"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "FragmentSpread",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "PostAttachmentsFields"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "mentionedUsers"
                                                                        },
                                                                        directives: [
                                                                            {
                                                                                kind: "Directive",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "connection"
                                                                                },
                                                                                arguments: [
                                                                                    {
                                                                                        kind: "Argument",
                                                                                        name: {
                                                                                            kind: "Name",
                                                                                            value: "key"
                                                                                        },
                                                                                        value: {
                                                                                            kind: "StringValue",
                                                                                            value: "mentionedUsers",
                                                                                            block: false
                                                                                        }
                                                                                    }, 
                                                                                ]
                                                                            }, 
                                                                        ],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "edges"
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "node"
                                                                                                },
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "Field",
                                                                                                            name: {
                                                                                                                kind: "Name",
                                                                                                                value: "id"
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            kind: "Field",
                                                                                                            name: {
                                                                                                                kind: "Name",
                                                                                                                value: "fullName"
                                                                                                            }
                                                                                                        },
                                                                                                        {
                                                                                                            kind: "Field",
                                                                                                            name: {
                                                                                                                kind: "Name",
                                                                                                                value: "avatarUrl"
                                                                                                            }
                                                                                                        }, 
                                                                                                    ]
                                                                                                }
                                                                                            }, 
                                                                                        ]
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "user"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "fullName"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "firstName"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "avatarUrl"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "roles"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PostAttachmentsFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "PostAttachment"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "attachmentType"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fileSizeInBytes"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "url"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "altText"
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SectionListDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "SectionList"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "isCoursesToCommunitiesEnabled"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communitySections"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "SectionFields"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SpaceFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunitySpace"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "iconName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "position"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "s3UploadPath"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isExclusive"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "posts"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communityProductRelation"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isCoursesToCommunitiesEnabled"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "product"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SectionFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunitySection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communitySpaces"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "connection"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "key"
                                        },
                                        value: {
                                            kind: "StringValue",
                                            value: "communitySpaces",
                                            block: false
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "SpaceFields"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "posts"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "id"
                                                                                                }
                                                                                            }, 
                                                                                        ]
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "totalCount"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var SiteFeaturesDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "SiteFeatures"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "site"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "features"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "communities"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "maxCommunitySpaces"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityEvents"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isEnabled"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityEventNotifications"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "isEnabled"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communitySections"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "communitySpaces"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "totalCount"
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CreateCommunitySpaceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "CreateCommunitySpace"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CreateCommunitySpaceInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createCommunitySpace"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communitySpace"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UpdateCommunitySpaceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "UpdateCommunitySpace"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "UpdateCommunitySpaceInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "updateCommunitySpace"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communitySpace"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var DeleteCommunitySpaceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "DeleteCommunitySpace"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "DeleteCommunitySpaceInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deleteCommunitySpace"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var ReorderCommunitySpaceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ReorderCommunitySpace"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ReorderCommunitySpaceInput"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "reorderCommunitySpace"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "userErrors"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "code"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var CommunitySpaceDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "CommunitySpace"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "spaceId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "isCoursesToCommunitiesEnabled"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communitySpace"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "spaceId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "SpaceFields"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "SpaceFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunitySpace"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "iconName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "position"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageUrl"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "imageAltText"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "s3UploadPath"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isExclusive"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "posts"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "communityProductRelation"
                        },
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "include"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "isCoursesToCommunitiesEnabled"
                                            }
                                        }
                                    }, 
                                ]
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "product"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UsersDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Users"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "searchTerm"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    },
                    defaultValue: {
                        kind: "StringValue",
                        value: "",
                        block: false
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numberOfUsers"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    },
                    defaultValue: {
                        kind: "IntValue",
                        value: "5"
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "after"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communityUsers"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "numberOfUsers"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "after"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "after"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "active"
                                                        },
                                                        value: {
                                                            kind: "BooleanValue",
                                                            value: true
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "totalCount"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "pageInfo"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "endCursor"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "startCursor"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "CommunityEdgesFields"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "mentionableUsers"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "searchTerm"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "searchTerm"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "numberOfUsers"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "user"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "fullName"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "profile"
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "id"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "avatarUrl"
                                                                                                }
                                                                                            }, 
                                                                                        ]
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesNodeUserFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "User"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "fullName"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "profile"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "roles"
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesNodeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunityUser"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "user"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "permissions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        }, 
                                    ]
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "CommunityEdgesNodeUserFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "CommunityEdgesFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CommunityUserEdge"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "node"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "CommunityEdgesNodeFields"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var UserDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "User"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "userId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "numOfCourses"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "endCursor"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communityUser"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "userId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "userId"
                                                }
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "canModerate"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "user"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "fullName"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "firstName"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "roles"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "profile"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "avatarUrl"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "company"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "headline"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "timezone"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "enrollments"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "status"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "COMPLETED"
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productStatus"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "published"
                                                                                        }, 
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productVisible"
                                                                                },
                                                                                value: {
                                                                                    kind: "BooleanValue",
                                                                                    value: true
                                                                                }
                                                                            }, 
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "orderBy"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "field"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "COMPLETED_AT"
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "direction"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "DESC"
                                                                                }
                                                                            }, 
                                                                        ]
                                                                    }
                                                                },
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "first"
                                                                    },
                                                                    value: {
                                                                        kind: "Variable",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "numOfCourses"
                                                                        }
                                                                    }
                                                                },
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "after"
                                                                    },
                                                                    value: {
                                                                        kind: "Variable",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "endCursor"
                                                                        }
                                                                    }
                                                                }, 
                                                            ],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "UserEnrollmentFields"
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "UserEnrollmentFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "EnrollmentConnection"
                }
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cursor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "completedAt"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "course"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "cardImageUrl"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "resumeCourseUrl"
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "landingPageUrl"
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var MainDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "Main"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "communityId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }, 
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "site"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "favicon"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "filestackPolicy"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "policy"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "signature"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "featureFlags"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "subdomain"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "trackingKey"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "whiteLabellingActivated"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "googleAnalyticsKey"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appcuesDisabled"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "integrations"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "facebookPixelCode"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "gaMeasurementId"
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "community"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "communityId"
                                    }
                                }
                            }, 
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "description"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "primaryColor"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "font"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "imageUrl"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "s3UploadPath"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "published"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "communityUsers"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "active"
                                                        },
                                                        value: {
                                                            kind: "BooleanValue",
                                                            value: true
                                                        }
                                                    }, 
                                                ]
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "totalCount"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "mentionableUsers"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "searchTerm"
                                            },
                                            value: {
                                                kind: "StringValue",
                                                value: "",
                                                block: false
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "5"
                                            }
                                        }, 
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "user"
                                                                        },
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "fullName"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "profile"
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "id"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "avatarUrl"
                                                                                                }
                                                                                            }, 
                                                                                        ]
                                                                                    }
                                                                                }, 
                                                                            ]
                                                                        }
                                                                    }, 
                                                                ]
                                                            }
                                                        }, 
                                                    ]
                                                }
                                            }, 
                                        ]
                                    }
                                }, 
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "me"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fullName"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "email"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avatarUrl"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "roles"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "locale"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "profile"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timezone"
                                                }
                                            }, 
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "permissions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "communityId"
                                                }
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "resourceType"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "Community"
                                            }
                                        }, 
                                    ]
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};
var AccountNotificationsDocument = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "AccountNotifications"
            },
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "accountNotifications"
                        },
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isEnabled"
                                    }
                                }, 
                            ]
                        }
                    }, 
                ]
            }
        }, 
    ]
};


/***/ }),

/***/ 31785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42990);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67421);
/* harmony import */ var _AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16130);
/* harmony import */ var _AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_AdminOnlyIndicator_module_scss__WEBPACK_IMPORTED_MODULE_4___default()));
var AdminOnlyIndicator = function() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx("admin-only-indicator"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx("admin-only-indicator__icon"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_5__.I, {
                    name: "eye"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: cx("admin-only-indicator__message"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: t("components-adminOnlyIndicator-info_message", "Only admins can see this")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdminOnlyIndicator);


/***/ }),

/***/ 11357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9973);




var CommunityHeader = function(param) {
    var pageTitle = param.pageTitle;
    var community = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_3__/* .useCommunityContext */ .v1)().community;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
            children: [
                pageTitle,
                " | ",
                community.name
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CommunityHeader);


/***/ }),

/***/ 24159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47166);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67421);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(90923);
/* harmony import */ var toga__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82633);
/* harmony import */ var components_CommunityContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9973);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59830);
/* harmony import */ var helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17981);
/* harmony import */ var utils_userHelpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73652);
/* harmony import */ var utils_routerHelpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4154);
/* harmony import */ var constants_featureFlags__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(46139);
/* harmony import */ var components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(65699);
/* harmony import */ var components_SiteFeaturesContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40670);
/* harmony import */ var _EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64324);
/* harmony import */ var _EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14__);
















var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default().bind((_EventCard_module_scss__WEBPACK_IMPORTED_MODULE_14___default()));
var EventCard = function(param) {
    var id = param.id, title = param.title, imageUrl = param.imageUrl, imageAltText = param.imageAltText, startTime = param.startTime, endTime = param.endTime, timezone = param.timezone, isPreview = param.isPreview, interestedUserCount = param.interestedUserCount, isInterested = param.isInterested;
    var ref;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)().t;
    var ref1 = (0,components_CommunityContext__WEBPACK_IMPORTED_MODULE_6__/* .useCommunityContext */ .v1)(), currentUser = ref1.currentUser, community = ref1.community, featureFlags = ref1.featureFlags;
    var siteFeatures = (0,components_SiteFeaturesContext__WEBPACK_IMPORTED_MODULE_13__/* .useSiteFeaturesContext */ .Er)().siteFeatures;
    var eventNotificationsEnabled = siteFeatures === null || siteFeatures === void 0 ? void 0 : (ref = siteFeatures.communityEventNotifications) === null || ref === void 0 ? void 0 : ref.isEnabled;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref2 = (0,components_Events_hooks_useEventInterest__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(id), addInterest = ref2.addInterest, removeInterest = ref2.removeInterest, loading = ref2.loading;
    var rsvpEnabled = featureFlags[constants_featureFlags__WEBPACK_IMPORTED_MODULE_11__/* .features.COMMUNITIES_EVENTS_RSVP */ .R.COMMUNITIES_EVENTS_RSVP];
    var formattedDate = (0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .localeEventsDate */ .U0)(startTime, currentUser.locale, timezone);
    var getBadgeText = function() {
        if ((0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventLive */ .MF)(startTime, endTime)) return t("components-events-eventCard-live", "Live");
        if ((0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventStartingSoon */ .HE)(startTime, 15)) return t("components-events-eventCard-starting_soon", "Starting soon");
        return "";
    };
    var actions = [];
    var statusList = [];
    var isPastEvent = new Date() > new Date(endTime);
    if (rsvpEnabled && eventNotificationsEnabled && id) {
        if ((0,utils_userHelpers__WEBPACK_IMPORTED_MODULE_9__/* .canEditEvent */ .F5)(currentUser)) {
            actions.push({
                name: "Edit",
                text: t("common-EDIT", "EDIT"),
                onClick: function() {
                    (0,utils_routerHelpers__WEBPACK_IMPORTED_MODULE_10__/* .goToEditEvent */ .zf)(router, id, community.id);
                }
            });
            if (interestedUserCount) {
                statusList.push(t("components-events-interested_total", "{{total}} Interested", {
                    total: interestedUserCount
                }));
            }
        } else if (!isPastEvent) {
            if (isInterested) {
                // Interested Student
                actions.push({
                    name: "Remove Interest",
                    iconLeft: "minus",
                    text: t("components-events-eventCard-REMOVE_INTEREST", "REMOVE INTEREST"),
                    onClick: function() {
                        removeInterest();
                    }
                });
                if (interestedUserCount === 1) {
                    // There is only one interested student and it is you
                    statusList.push({
                        text: t("components-events-interested", "Interested"),
                        type: "active"
                    });
                } else if (interestedUserCount) {
                    // There are many interested including you
                    statusList.push({
                        text: t("components-events-you_and_others_interested", "You & {{total}} Interested", {
                            total: interestedUserCount - 1
                        }),
                        type: "active"
                    });
                }
            } else {
                // Student and they are not interested
                actions.push({
                    name: "Express Interest",
                    iconLeft: "plus",
                    text: t("components-events-eventCard-INTERESTED", "INTERESTED"),
                    onClick: function() {
                        addInterest();
                    }
                });
                if (interestedUserCount) {
                    statusList.push({
                        text: t("components-events-interested_total", "{{total}} Interested", {
                            total: interestedUserCount
                        }),
                        type: "inactive"
                    });
                }
            }
        }
    }
    var showFooter = !!actions.length;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(toga__WEBPACK_IMPORTED_MODULE_5__/* .Card */ .Zb, {
        badgeText: isPreview ? "" : getBadgeText(),
        badgeType: (0,helpers_dateHelpers__WEBPACK_IMPORTED_MODULE_8__/* .isEventLive */ .MF)(startTime, endTime) ? "danger" : "success",
        caption: formattedDate,
        className: cx("event-card"),
        footerActions: showFooter && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_15__.I, {
            actions: actions,
            ariaLabel: t("components-events-eventCard-dropdown_aria_label", "Event Card Dropdown"),
            buttonAppearance: "knockout"
        }),
        image: imageUrl || utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .EVENT_IMAGE_PLACEHOLDER */ .dm,
        imageAlt: imageAltText || "",
        isDisabled: loading,
        name: title,
        statusList: statusList,
        invertedCaption: true
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EventCard);


/***/ }),

/***/ 4069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ InfoCard_InfoCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(47166);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./components/Card/Card.module.scss
var Card_module = __webpack_require__(25079);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./components/Card/Card.tsx




var cx = bind_default().bind((Card_module_default()));
var Card = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx("card"),
        children: children
    });
};
/* harmony default export */ var Card_Card = (Card);

;// CONCATENATED MODULE: ./components/Card/index.ts


// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/IconButton-9b57b44f.js
var IconButton_9b57b44f = __webpack_require__(65569);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./hooks/useLocalStorage.ts
var useLocalStorage = __webpack_require__(6482);
// EXTERNAL MODULE: ./components/InfoCard/InfoCard.module.scss
var InfoCard_module = __webpack_require__(4856);
var InfoCard_module_default = /*#__PURE__*/__webpack_require__.n(InfoCard_module);
;// CONCATENATED MODULE: ./components/InfoCard/InfoCard.tsx








var InfoCard_cx = bind_default().bind((InfoCard_module_default()));
var InfoCard = function(param) {
    var isDismissable = param.isDismissable, title = param.title, isCompact = param.isCompact, children = param.children, localStorageKey = param.localStorageKey, dataQA = param.dataQA, onClose = param.onClose, wrapper = param.wrapper;
    var t = (0,es/* useTranslation */.$G)().t;
    var ref = (0,useLocalStorage/* default */.Z)(localStorageKey || ""), isSaved = ref.isSaved, saveKeyInLocalStorage = ref.saveKeyInLocalStorage;
    if (isDismissable && isSaved) return null;
    // If no localStorageKey is provided, then we know
    // that the component should be shown back if the user
    // refreshes/goes away and comes back to the page where
    // the section shown.
    var handleHideSection = function() {
        if (localStorageKey) saveKeyInLocalStorage(true);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    var dismissButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton_9b57b44f.I, {
        appearance: "utility",
        className: InfoCard_cx("info-card__dismiss-button"),
        name: "x-dismiss",
        title: t("common-dismiss-empty-state", "Dismiss the {{title}} section", {
            title: title
        }),
        onClick: handleHideSection
    });
    var Wrapper = wrapper || Card_Card;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: InfoCard_cx("info-card", {
                "info-card--compact": isCompact
            }),
            "data-qa": dataQA,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: InfoCard_cx("info-card__dismiss-wrapper"),
                    children: isDismissable && dismissButton
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: InfoCard_cx("info-card__header", {
                        "info-card__header--dismissable": isDismissable
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: InfoCard_cx("info-card__title", {
                            "info-card__title--compact": isCompact
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: title
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: children
                })
            ]
        })
    });
};
/* harmony default export */ var InfoCard_InfoCard = (InfoCard);

;// CONCATENATED MODULE: ./components/InfoCard/index.ts



/***/ }),

/***/ 6482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useLocalStorage = function(localStorageKey) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!!localStorage.getItem(localStorageKey)), isSaved = ref[0], setIsSaved = ref[1];
    var getKeyFromLocalStorage = function() {
        var value = localStorage.getItem(localStorageKey);
        if (value) return JSON.parse(value);
        return null;
    };
    var saveKeyInLocalStorage = function(value) {
        try {
            localStorage.setItem(localStorageKey, JSON.stringify(value));
            setIsSaved(true);
        } catch (e) {
            setIsSaved(false);
        }
    };
    var removeKeyFromLocalStorage = function() {
        try {
            localStorage.removeItem(localStorageKey);
            setIsSaved(false);
        } catch (e) {
            setIsSaved(true);
        }
    };
    return {
        isSaved: isSaved,
        getKeyFromLocalStorage: getKeyFromLocalStorage,
        removeKeyFromLocalStorage: removeKeyFromLocalStorage,
        saveKeyInLocalStorage: saveKeyInLocalStorage
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useLocalStorage);


/***/ }),

/***/ 23077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ togaFooterBlockName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _thinkific_toga_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > div[class*='footer'] {\n    box-sizing: border-box;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var togaFooterBlockName = "card__footer";
// Toga's react version of this card is missing border-box 🙃
// Card footers render twice as large without it
var wrapped = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_thinkific_toga_react__WEBPACK_IMPORTED_MODULE_2__.C)(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (wrapped);


/***/ }),

/***/ 82633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Zb": function() { return /* reexport */ Card/* default */.Z; },
  "JX": function() { return /* reexport */ Col; },
  "W2": function() { return /* reexport */ Container; },
  "ub": function() { return /* reexport */ EmptyState; },
  "II": function() { return /* reexport */ Input; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Row-ef6c768c.js
var Row_ef6c768c = __webpack_require__(93928);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./toga/Container.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var wrapped = (0,styled_components_browser_esm/* default */.ZP)(Row_ef6c768c.C)(_templateObject());
/* harmony default export */ var Container = (wrapped);

;// CONCATENATED MODULE: ./toga/Col.tsx

function Col_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: border-box;\n"
    ]);
    Col_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Col_wrapped = (0,styled_components_browser_esm/* default */.ZP)(Row_ef6c768c.a)(Col_templateObject());
/* harmony default export */ var Col = (Col_wrapped);

// EXTERNAL MODULE: ./toga/Card.tsx
var Card = __webpack_require__(23077);
// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/EmptyState-281bc093.js
var EmptyState_281bc093 = __webpack_require__(94659);
;// CONCATENATED MODULE: ./toga/EmptyState.tsx

function EmptyState_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  h2 {\n    font-family: inherit;\n  }\n"
    ]);
    EmptyState_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var EmptyState_wrapped = (0,styled_components_browser_esm/* default */.ZP)(EmptyState_281bc093.E)(EmptyState_templateObject());
/* harmony default export */ var EmptyState = (EmptyState_wrapped);

// EXTERNAL MODULE: ./node_modules/@thinkific/toga-react/dist/es/Input-b1273534.js + 2 modules
var Input_b1273534 = __webpack_require__(28032);
;// CONCATENATED MODULE: ./toga/Input.tsx

function Input_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  input {\n    box-sizing: border-box;\n  }\n"
    ]);
    Input_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Input_wrapped = (0,styled_components_browser_esm/* default */.ZP)(Input_b1273534.I)(Input_templateObject());
/* harmony default export */ var Input = (Input_wrapped);

;// CONCATENATED MODULE: ./toga/index.ts








/***/ }),

/***/ 16130:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"AdminOnlyIndicator_sr-only--mobile__V_O5h","sr-only":"AdminOnlyIndicator_sr-only__qudiG","error-message":"AdminOnlyIndicator_error-message__o6_Mk","form-inline-edit":"AdminOnlyIndicator_form-inline-edit__1rOMu","form-group":"AdminOnlyIndicator_form-group__P_zKT","form-row":"AdminOnlyIndicator_form-row__EzBE2","form-inline":"AdminOnlyIndicator_form-inline__NoKeJ","error":"AdminOnlyIndicator_error__DTNfK","input-group-append":"AdminOnlyIndicator_input-group-append__lhDS3","input-group-currency":"AdminOnlyIndicator_input-group-currency__0zgWg","form-control":"AdminOnlyIndicator_form-control__7nBF_","custom-select":"AdminOnlyIndicator_custom-select__wW7Y_","is-invalid":"AdminOnlyIndicator_is-invalid__xLyF6","is-valid":"AdminOnlyIndicator_is-valid__3bhop","input-group":"AdminOnlyIndicator_input-group__th3eH","input-group-text":"AdminOnlyIndicator_input-group-text__HXMCd","input-group-prepend":"AdminOnlyIndicator_input-group-prepend__xd9BQ","valid-feedback":"AdminOnlyIndicator_valid-feedback__3RqVS","invalid-feedback":"AdminOnlyIndicator_invalid-feedback__vVLXV","form-text":"AdminOnlyIndicator_form-text__EMwMA","label":"AdminOnlyIndicator_label__htcqJ","custom-control":"AdminOnlyIndicator_custom-control__n1VIY","custom-control-label":"AdminOnlyIndicator_custom-control-label__FAv4l","custom-control-label--empty":"AdminOnlyIndicator_custom-control-label--empty__aMFmr","custom-control-input":"AdminOnlyIndicator_custom-control-input__TrqAO","admin-only-indicator":"AdminOnlyIndicator_admin-only-indicator__mMTxj","admin-only-indicator__icon":"AdminOnlyIndicator_admin-only-indicator__icon__Ly9X8","admin-only-indicator__message":"AdminOnlyIndicator_admin-only-indicator__message__c98W5"};

/***/ }),

/***/ 25079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"Card_sr-only--mobile__pyBUz","sr-only":"Card_sr-only__SIhMy","error-message":"Card_error-message__yZHay","form-inline-edit":"Card_form-inline-edit__O7lAa","form-group":"Card_form-group__6a19M","form-row":"Card_form-row__GyjgV","form-inline":"Card_form-inline__JC07O","error":"Card_error__AZsoV","input-group-append":"Card_input-group-append__4S9l1","input-group-currency":"Card_input-group-currency__cBLyv","form-control":"Card_form-control__FKUhb","custom-select":"Card_custom-select__wAwyN","is-invalid":"Card_is-invalid__mruvn","is-valid":"Card_is-valid__6nnKW","input-group":"Card_input-group__ZVE3x","input-group-text":"Card_input-group-text__JjRPi","input-group-prepend":"Card_input-group-prepend__4FTVF","valid-feedback":"Card_valid-feedback__LJdLl","invalid-feedback":"Card_invalid-feedback__tZSON","form-text":"Card_form-text__t8Ua4","label":"Card_label__sW6BW","custom-control":"Card_custom-control__r_5XG","custom-control-label":"Card_custom-control-label__g1TZ4","custom-control-label--empty":"Card_custom-control-label--empty__zEhvd","custom-control-input":"Card_custom-control-input__7ePj9","card":"Card_card__pfJM5"};

/***/ }),

/***/ 64324:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"event-card":"EventCard_event-card__vqeTZ","event-card__title":"EventCard_event-card__title__RgU1t"};

/***/ }),

/***/ 4856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sr-only--mobile":"InfoCard_sr-only--mobile__i601v","sr-only":"InfoCard_sr-only__vL_gU","error-message":"InfoCard_error-message__c92GS","form-inline-edit":"InfoCard_form-inline-edit__TJwoX","form-group":"InfoCard_form-group__keMqm","form-row":"InfoCard_form-row__Qyw2B","form-inline":"InfoCard_form-inline__jbZ4A","error":"InfoCard_error__YP2_l","input-group-append":"InfoCard_input-group-append___EsaJ","input-group-currency":"InfoCard_input-group-currency__aO0mN","form-control":"InfoCard_form-control__sVJ7H","custom-select":"InfoCard_custom-select__Biz3h","is-invalid":"InfoCard_is-invalid__CfhOh","is-valid":"InfoCard_is-valid__dLrJq","input-group":"InfoCard_input-group__xgz5V","input-group-text":"InfoCard_input-group-text__w0tjr","input-group-prepend":"InfoCard_input-group-prepend__K0SE5","valid-feedback":"InfoCard_valid-feedback__fFNYh","invalid-feedback":"InfoCard_invalid-feedback__ej2M8","form-text":"InfoCard_form-text__2NXrk","label":"InfoCard_label__NAJgQ","custom-control":"InfoCard_custom-control___On2o","custom-control-label":"InfoCard_custom-control-label__LEWoW","custom-control-label--empty":"InfoCard_custom-control-label--empty__iiBN4","custom-control-input":"InfoCard_custom-control-input__yntTp","info-card":"InfoCard_info-card__ygNJi","info-card--compact":"InfoCard_info-card--compact__j4bx7","info-card__header":"InfoCard_info-card__header__g_F2p","info-card__header--dismissable":"InfoCard_info-card__header--dismissable__TNoXX","info-card__title":"InfoCard_info-card__title__rzlR1","info-card__title--compact":"InfoCard_info-card__title--compact__rq0x8","info-card__dismiss-wrapper":"InfoCard_info-card__dismiss-wrapper__ESdSm"};

/***/ })

}]);